import React, { useState, useEffect, useRef } from "react";
import { Button, Card, Modal, OverlayTrigger } from "react-bootstrap";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RecogObj from "../../service/api/recognition/captureAndRecognize";
import WhiteGreenButton from "../../jsx/components/button/whiteGreenButton";
import ScanResultModal from "../../jsx/components/scanResultModal/scanResultModal";
import UserFeedbackApi from "../../service/api/recognition/userFeedback";
import { addFCMToken } from "../../service/api/user/addFCMToken";
import imageCompression from 'browser-image-compression';
import { Carousel } from 'react-bootstrap';
import Webcam from 'react-webcam';

import CreateTicket from "../../service/api/ticket/createTicket";
import {
  backDropLoaderRejectedCaseRedux,
  backLoaderFalse,
  backLoaderTrue,
  setCurrentPage,
  setLoaderTime,
  setUserDetails,
  updateServiceReqModalFalse,
} from "../../feature/userData/userData";
import { getProductType } from "../../service/api/object/getProdType";
import { getBrandFromProductId } from "../../service/api/object/getBrand";
import { addBrand } from "../../service/api/object/addBrand";
import { getCat } from "../../service/api/object/getCat";
import DummyBackdropLoader from "../../component/backDrop/dummyBackDropLoader";
import BackDropLoaderRejectedCase from "../../component/backDrop/backDropLoaderRejectedCase";
import BackDrop from "../../component/backDrop/backDropLoader";
import ErrorBackdropLoader from "../../component/backDrop/errorBackDropLoader";
import UpdateServiceRequest from "../../component/updateServiceRequest/updateServiceRequest";
import { requestForToken } from "../../firebase";
import FcmTokenVerify from "../../component/fcmTokenVerify/fcmTokenVerify";

import appliancesImg from "../../media/images/appliancesImg.png";
import electricalImg from "../../media/images/electricalImg.png";
import hvacImg from "../../media/images/hvacImg.png";
import landscapingImg from "../../media/images/landscapingImg.png";
import plumbingImg from "../../media/images/plumbingImg.png";
import unavailbleServiceImg from '../../media/images/servicesAssets/unavailbleServiceImg.png'

import "./scan.scss";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import { Tooltip } from "chart.js";
import { createPaymentMethod } from "../../service/api/paymentGateway/createPaymentMethod";
import creditCardType from "credit-card-type";
import validator, { isPostalCode } from "validator";
import Cards from "react-credit-cards";
import InputField from "../../jsx/components/fields/inputField";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import { userById } from "../../service/api/user/userById";
import { getPaymentMethodListByCustomerId } from "../../service/api/paymentGateway/getPaymentMethodListByCustomerId";
import UpdateCardDetails from "../paymentModule/updateCardDetails";
import setDefaultPaymentMethodById from "../../service/api/paymentGateway/setDefaultPaymentMethodById";
import AddNewCard from "../paymentModule/addNewCard";
import TextArea from "../../jsx/components/fields/textArea";
import {
  txtScanHelpUs,
  btnReScan,
  btnIdentifyManually,
  btnRecognize,
  errEmptyEmailOrPhone,
  validEmail_OR_MobileNumberText,
} from "../../dataBaseFile/label";
import serviceImg from "../../media/images/serviceImg.gif";
import ocr from "../../service/api/recognition/ocr";
import { getPaymentConfigApi } from "../../service/api/paymentGateway/getPaymentConfig";
import { checkPromoCode } from "../../service/api/paymentGateway/checkPromoCode";
import { getPaymentMethodSupportedList } from "../../service/api/paymentGateway/getPaymentMethodSupportedList";

import DatePicker from "react-datepicker";
import { format } from "date-fns";
import calendarImg from "../../media/images/servicesAssets/calendarImg.png";
import BackDropReconnecting from "../../component/backDrop/backDropReconnecting";

import { Elements, CardElement, useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { CardNumberInput, CardExpiryInput, CardCvcInput } from '../paymentModule/cardElements/cardInput';
import axios from "axios";
import StandardInputField from "../../jsx/components/fields/standardInputField";
import sourcingInfoFromDeviceModelApi from "../../service/api/object/sourcingInfoFromDeviceModel";
import searchImg from '../../media/images/servicesAssets/searchImg.png'
import BarQrScanner from "./barcodeScanner";
import { ImageCropper } from "./ImageCropper";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { noSpaceOnChange, phoneValidation } from "../../validations/validation";
import { emailValidation } from "../../functions/validations";
import { getInviteAndRegisteredUsersApi } from "../../service/api/user/getInviteAndRegisteredUsers";
import SearchableSelect from "../../jsx/components/fields/serchableSelect";
import createViaRoleApi from "../../service/api/ticket/createViaRole";
import SearchableSelectForInvites from "../../jsx/components/fields/searchableSelectForInvites";
import InviteProModal from "../../jsx/components/inviteProModal/inviteProModal";


const Scan = ({
  DIYProjectId = "",
  DIYProjectDescription = "",
}) => {

  const {
    role,
    backDropLoaderStatus,
    updateServiceRequestStatus,
    backDropLoaderRejectedCase,
    paymentMethodID,
    customerID,
    impersonateFlag,
    permissionArr,
    totalCreditsInCents
  } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const permissionArray = permissionArr[0] || []

  const [stream, setStream] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resValue, setResValue] = useState("");

  const [isResValue, setIsResValue] = useState(false);
  const [shouldFaceUser, setShouldFaceUser] = useState(true);
  const [canvasEnabled, setCanvasEnabled] = useState(false);
  const [responseBox, setResponseBox] = useState(false);
  const [selectClassBox, setSelectClassBox] = useState(false);
  const [responseOnCrop, setResponseOnCrop] = useState("");

  const [loadingArr, setLoadingArr] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [showFeedback, setShowFeedback] = useState(false);
  const [catArr, setCatArr] = useState([]);

  const [prodTypeArr, setProdTypeArr] = useState([]);
  const [brandArr, setBrandArr] = useState([]);
  const [catId, setCatId] = useState();

  const [prodTypeId, setProdTypeId] = useState();
  const [brandId, setBrandId] = useState();
  const [labelName, setLabelName] = useState("Category");

  const [newProdType, setNewProdType] = useState("");
  const [newBrand, setNewBrand] = useState("");
  const [productName, setProductName] = useState("");
  const [modelNum, setModelNum] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [tagNum, setTagNum] = useState("");
  const [description, setDescription] = useState(DIYProjectDescription || "");
  const [image, setImage] = useState("");
  const [predictionFlag, setPredictionFlag] = useState(false);
  const [predictedObjectClassId, setPredictedObjectClassId] = useState();
  const [predictedObjectClassName, setPredictedObjectClassName] = useState();
  const [predictedLogId, setPredictedLogId] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedArr, setSearchedArr] = useState([]);
  const [breadCatName, setBreadCatName] = useState();
  const [breadCatButtonName, setBreadCatButtonName] = useState();
  const [breadProductName, setBreadProductName] = useState();
  const [breadBrandName, setBreadBrandName] = useState();
  const [pageSizeCat, setPageSizeCat] = useState(5);
  const [pageCat, setPageCat] = useState(1);
  const [pageSizeProductType, setPageSizeProductType] = useState(5);
  const [pageProductType, setPageProductType] = useState(1);
  const [pageSizeBrand, setPageSizeBrand] = useState(5);
  const [pageBrand, setPageBrand] = useState(1);
  const [pageSizeSearch, setPageSizeSearch] = useState(5);
  const [pageSearch, setPageSearch] = useState(1);
  const [totalCountSearch, setTotalCountSearch] = useState(0);
  const [totalCountCat, setTotalCountCat] = useState(0);
  const [totalCountProductType, setTotalCountProductType] = useState(0);
  const [totalCountBrand, setTotalCountBrand] = useState(0);
  const [feedbackStart, setFeedbackStart] = useState(0);
  const [responseAfterSubmit, setResponseAfterSubmit] = useState("");
  const [responseBoxAfterFeedback, setResponseBoxAfterSubmit] = useState(false);
  const [addUnknwBrandArr, setAddUnknwBrandArr] = useState([]);
  const [addUnknwProdArr, setAddUnknwProdArr] = useState([]);
  const [catOrder, setCatOrder] = useState("ASC");
  const [prodOrder, setProdOrder] = useState("ASC");
  const [brandOrder, setBrandOrder] = useState("ASC");
  const [videoWidth, setVideoWidth] = useState();
  const [videoHeight, setVideoHeight] = useState();
  const [productNameForTicket, setProductNameForTicket] = useState("");
  const [isDescrError, setIsDescrError] = useState(false);
  const [displayImage, setDisplayImage] = useState();
  const [backDropLoader, setBackDropLoader] = useState(false);
  const [backDropLoaderResp, setBackDropLoaderResp] = useState(false);
  const [errBackDropLoaderResp, setErrBackDropLoaderResp] = useState(false);
  const [ticketLoading, setTicketLoading] = useState(false);
  const [timeSlotArr, setTimeSlotArr] = useState([]);
  const [comminicationModeArr, setCommunicationModeArr] = useState([]);

  const [objectCategoryName, setObjectCategoryName] = useState("");
  const [uploadAttachedImage1, setUploadAttachedImage1] = useState(null);
  const [attachedImage1, setAttachedImage1] = useState(null);

  const [uploadAttachedImage2, setUploadAttachedImage2] = useState(null);
  const [attachedImage2, setAttachedImage2] = useState(null);
  const [documentType, setDocumentType] = useState();
  const [openDoc, setOpenDoc] = React.useState(false);
  const [productTypeResp, setProductTypeResp] = useState(false);

  const [particularID, setParticularID] = useState();

  const [isCustomResMsg, setIsCustomResMsg] = useState(false);

  const [deviceBrandChr, setDeviceBrandChr] = useState();
  const [deviceColorChr, setDeviceColorChr] = useState();

  const [isScheduledCall, setIsScheduledCall] = useState(false);

  const [myCountryCode, setMyCountryCode] = useState('US');

  const [serviceSearchProFlag, setServiceSearchProFlag] = useState();
  const [qrModalStatus, setQrModalStatus] = useState(false)
  const [qrResult, setQrResult] = useState("")

  const [objectCondition, setObjectCondition] = useState('');

  const [isCreditsUsed, setIsCreditsUsed] = useState(false);

  const [predictedObjectDetails, setPredictedObjectDetails] = useState({})

  function handleQrModalStatus() {
    if (qrModalStatus) {
      setResponseBox(true)
    } else {
      setResponseBox(false)
    }
    setQrModalStatus(!qrModalStatus)
  }
  useEffect(() => {
    dispatch(setCurrentPage("Connect to pro"));
  }, []);

  useEffect(() => {
    dispatch(updateServiceReqModalFalse());
  }, []);

  const handleCloseOnlyResBox = () => {
    setResponseBox(false);
    setIsCustomResMsg(false);
    setShowFeedback(false);
    getMediaStream();
    setCanvasEnabled(false);

    setUserInvitationId('');
    setUserId('');
    setIsProSelected(false);
  };
  // Tooltips here
  const tooltipProduct = (
    <Tooltip id="tooltip">
      <strong>Select product type</strong>
    </Tooltip>
  );
  const tooltipCloseProducts = (
    <Tooltip id="tooltip">
      <strong>Close product type</strong>
    </Tooltip>
  );

  const handleCloseDoc = () => setOpenDoc(false);

  const [FcmModalTrigger, setFcmModalTrigger] = useState(false);
  const handleCloseFCM = () => setFcmModalTrigger(false);
  // useEffect(() => {
  //   if (!localStorage.getItem('fcm_token')) {
  //     requestForToken();

  //     setTimeout(() => {
  //       retakeTokenFn();
  //     }, 3000)
  //   }
  // }, [])

  const retakeTokenFn = () => {
    // if (!localStorage.getItem('fcm_token')) {
    //   let details = {
    //     user_id_int: localStorage.getItem("user_id"),
    //     fcm_token_chr: localStorage.getItem('fcm_token'),
    //   }
    //   dispatch(addFCMToken(details, (res) => { }, (err) => {
    //     setFcmModalTrigger(true)
    //   }))
    // }
  };

  useEffect(() => {
    var forCatData = {
      page_index: pageCat,
      page_size: pageSizeCat,
      sorting_order: catOrder,
    };

    dispatch(
      getCat(forCatData, (res) => {
        setCatArr(res.data.data);

        if (res.data.total_count % pageSizeCat === 0) {
          setTotalCountCat(parseInt(res.data.total_count / pageSizeCat));
        } else {
          setTotalCountCat(parseInt(res.data.total_count / pageSizeCat + 1));
        }
      })
    );
  }, [pageCat, pageSizeCat, catOrder]);

  function handleSetSearchedArrEle(ele) {
    setCatId(undefined);
    setProdTypeId(undefined);
    setBrandId(undefined);
    setBreadCatName("");
    setBreadCatButtonName("");
    setBreadProductName("");
    setBreadBrandName("");

    if (ele.category?.category_name_chr) {
      var set = {
        category_id_ids: ele.category?.category_id_ids,
        category_name_chr: ele.category?.category_name_chr,
      };

      handleSetCatId(set);
    }

    if (ele.product_type?.product_type_name_chr) {
      var prodT = {
        product_type_id_ids: ele.product_type?.product_type_id_ids,
        product_type_name_chr: ele.product_type?.product_type_name_chr,
      };
      handleSetProductType(prodT);
    }
    if (ele.product_brand?.brand_name_chr) {
      var brandT = {
        brand_id_ids: ele.product_brand?.brand_id_ids,
        brand_name_chr: ele.product_brand?.brand_name_chr,
      };
      handleSetBrandType(brandT);
      // setBrandId(ele.product_brand?.brand_id_ids)
    }
    setSearchText("");
    setIsSearch(false);
  }
  function handleChangeAddBrand(e) {
    setNewBrand(e.target.value);
  }
  function handleAddBrand() {
    var trim = newBrand.trim();
    if (trim.length > 0) {
      var data = {
        object_type_id_ids: prodTypeId,
        brand_name_chr: newBrand,
      };
      dispatch(
        addBrand(data, (res) => {
          setNewBrand("");

          var ele = {
            brand_id_ids: res.data.data.brand_id_ids,
            brand_name_chr: res.data.data.brand_name_chr,
          };
          handleSetBrandType(ele);
        })
      );
    }
  }
  function handleSearch(e) {
    setSearchText(e.target.value);
  }
  function handleSetCatId(ele) {
    if (ele.category_id_ids === -2) {
      setCatId(ele.category_id_ids);
      setProductNameForTicket("unknown");

      setProdTypeId(0);
      setBrandId(0);
      setLabelName("Details");
    } else {
      setLoadingArr(true);
      setProductTypeResp(true);
      // setProductNameForTicket(ele.category_name_chr)
      setCatId(ele.category_id_ids);
      setBreadCatName(ele.category_name_chr + " >> ");
      setObjectCategoryName(ele.category_name_chr);
      setBreadCatButtonName(ele.category_name_chr);
      setLabelName("Product Type");
      var data = {
        category_id_ids: ele.category_id_ids,
        page_size: 25,
      };

      dispatch(
        getProductType(
          data,
          (res) => {
            setLoadingArr(false);
            setProductTypeResp(false);
            setProdTypeArr(res.data.data);
            setAddUnknwProdArr(res.data.extra_options);
            if (res.data.total_count % pageSizeProductType === 0) {
              setTotalCountProductType(
                parseInt(res.data.total_count / pageSizeProductType)
              );
            } else {
              setTotalCountProductType(
                parseInt(res.data.total_count / pageSizeProductType + 1)
              );
            }
          },
          (err) => {
            setProductTypeResp(true);
          }
        )
      );
    }
  }

  function handleSetProductType(ele) {
    setResponseBox(true);
    if (ele.product_type_id_ids === -2) {
      setProdTypeId(ele.product_type_id_ids);
      setBrandId(0);
      setLabelName("Details");
    } else {
      setLoadingArr(true);
      setProdTypeId(ele.product_type_id_ids);
      setProductNameForTicket(ele.product_type_name_chr);
      // setPredictedObjectClassName(
      //   res.data.data.predicted_object_name
      // );
      setBreadProductName(ele.product_type_name_chr + " >> ");
      setLabelName("Brand Name");
      var data = {
        product_type_id_ids: ele.product_type_id_ids,
        page_index: pageBrand,
        page_size: pageSizeBrand,
      };
    }
  }

  function handleSetBrandType(ele) {
    setBrandId(ele.brand_id_ids);
    setBreadBrandName(ele.brand_name_chr);
    setLabelName("Details");
  }
  useEffect(() => {
    if (window.innerWidth > 520) {
      setVideoWidth(521);
      setVideoHeight(400);
    }
    if (window.innerWidth < 520 && window.innerWidth > 360) {
      setVideoWidth(510);
      setVideoHeight(400);
    }

    if (window.innerWidth < 360) {
      setVideoWidth(359);
      setVideoHeight(359);
    }
  }, []);
  window.addEventListener("resize", () => {
    // setImgSrc(null);
    if (window.innerWidth > 520) {
      setVideoWidth(521);
      setVideoHeight(400);
    }
    if (window.innerWidth < 520 && window.innerWidth > 360) {
      setVideoWidth(510);
      setVideoHeight(400);
    }

    if (window.innerWidth < 360) {
      setVideoWidth(359);
      setVideoHeight(359);
    }
  });

  async function getMediaStream() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: ["environment"],
        },
      });
      setStream(stream);
    } catch (error) {
      console.error("Error accessing media devices", error);
    }
  }
  useEffect(() => {
    getMediaStream();
  }, []);

  useEffect(() => {
    if (stream && videoRef.current) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);

  useEffect(() => {
    if (stream && videoRef.current) {
      if (showFeedback) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }

    }
  }, [stream, showFeedback]);

  useEffect(() => {
    return () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [stream]);



  const clearValue = () => {
    setTimeout(() => {
      setIsResValue(false);
    }, 2000);
  };




  const [productTypeDetected, setProductTypeDetected] = useState("");
  // console.log('productTypeDetected', productTypeDetected);

  function handleCloseResponseBox(data) {
    getMediaStream();
    setShowFeedback(false);
    setCanvasEnabled(false);
    setIsCustomResMsg(false);
    if (!predictionFlag) {
      setResponseBox(false);
      setCanvasEnabled(false);
      let formData = new FormData();

      formData.append("image", image, "jpg");
      formData.append("object_class_id", predictedObjectClassId);
      formData.append("prediction_logs_id", predictedLogId);
      formData.append("object_class_name", predictedObjectClassName);
      formData.append("feedback_flag_ysn", feedbackStart);
      formData.append("category_id_ids", 0);
      formData.append("sub_category_id_ids", 0);
      formData.append("product_type_id_ids", 0);
      formData.append("brand_id_ids", 0);
      formData.append("object_name_chr", productName);
      formData.append("object_model_number_chr", modelNum);
      formData.append("object_tag_chr", tagNum);
      formData.append("object_description_chr", description);

      dispatch(
        UserFeedbackApi(formData, (res) => {
          setShowFeedback(false);
          setCanvasEnabled(false);
          setImage();
          setPredictedLogId();
          setPredictedObjectClassId();
          setPredictedObjectClassName();
          setCatId();

          setProdTypeId();
          setBrandId();
          setProductName();
          // setModelNum();
          setTagNum();
          // setDescription();
          setBreadBrandName("");
          setBreadCatName("");
          setBreadCatButtonName("");

          setBreadProductName("");
          setFeedbackStart(0);
        })
      );
    } else {
      setProductTypeDetected(data);
      setResponseBox(false);
      setCanvasEnabled(false);
      // setShowFeedback(true);
      setFeedbackStart(1);
      setCatId(0);
      setProdTypeId(0);
      setBrandId(0);
    }
  }

  function handleResponseAgree() {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setShowFeedback(true);
    setFeedbackStart(1);
    setResponseBox(false);
  }

  function handleDescription(e) {
    setDescription(e.target.value);
  }

  function submitFeedback() {
    let formData = new FormData();
    let createTicketData = new FormData();

    createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
    // createTicketData.append("address_id_ids",0)
    //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
    // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
    createTicketData.append(
      "object_name_chr",
      productNameForTicket ? productNameForTicket : productTypeDetected
    );

    createTicketData.append("object_category_chr", objectCategoryName);
    modelNum && createTicketData.append("object_model_number_chr", modelNum);
    serialNumber && createTicketData.append("serial_number_chr", serialNumber);
    description &&
      createTicketData.append("problem_description_chr", description);
    deviceBrandChr &&
      createTicketData.append("device_brand_chr", deviceBrandChr);
    deviceColorChr &&
      createTicketData.append("device_color_chr", deviceColorChr);
    image &&
      createTicketData.append(
        "attachment0",
        image,
        "uploadAttachedImage0.jpeg"
      );
    uploadAttachedImage1 != null &&
      createTicketData.append(
        "attachment1",
        uploadAttachedImage1,
        "uploadAttachedImage1.jpeg"
      );
    uploadAttachedImage2 != null &&
      createTicketData.append(
        "attachment2",
        uploadAttachedImage2,
        "uploadAttachedImage2.jpeg"
      );
    createTicketData.append(
      "amount_after_discount",
      finalAmountAfterPromoCodeApplied
    );

    isCreditsUsed && createTicketData.append("use_credits_flag", isCreditsUsed);

    verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);
    qrResult && createTicketData.append("qr_info_chr", qrResult);
    objectCondition && createTicketData.append("condition_chr", objectCondition);
    DIYProjectId && createTicketData.append("project_id_ids", DIYProjectId);

    image && formData.append("image", image, "image.jpeg");
    formData.append("object_class_id", predictedObjectClassId);
    formData.append("prediction_logs_id", predictedLogId);
    formData.append("object_class_name", predictedObjectClassName);
    formData.append("feedback_flag_ysn", feedbackStart);
    formData.append("category_id_ids", catId);

    formData.append("product_type_id_ids", prodTypeId);
    formData.append("brand_id_ids", brandId);
    formData.append("object_name_chr", productName);
    formData.append("object_model_number_chr", modelNum);
    formData.append("object_tag_chr", tagNum);
    formData.append("object_description_chr", description);

    verifiedPromoCode && localStorage.getItem("isFreeSR") && createTicketData.append("is_free_sr", localStorage.getItem("isFreeSR") ? localStorage.getItem("isFreeSR") : 0);
    createTicketData.append("ticket_type", 1);

    let summary_meta_data = {
      recognized_image_summary: predictedObjectDetails?.predicted_object_info?.recognized_image_summary || '',
      recognized_estimation_summary: predictedObjectDetails?.predicted_object_info?.recognized_estimation_summary || '',
      recognized_repair_and_install_summary: predictedObjectDetails?.predicted_object_info?.recognized_repair_and_install_summary || '',
    }
    createTicketData.append("summary", JSON.stringify(summary_meta_data));

    setBackDropLoaderResp(true);
    dispatch(
      CreateTicket(
        createTicketData,
        (res) => {

          localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
          localStorage.setItem("proType", res.data.data.product_type_chr);
          setServiceSearchProFlag(res.data.search_pro)

          dispatch(setLoaderTime(res.data));

          setBackDropLoaderResp(false);
          dispatch(backLoaderTrue());

          localStorage.getItem("isFreeSR") && localStorage.removeItem("isFreeSR");
          localStorage.getItem("proCode") && localStorage.removeItem("proCode");


          // console.log("res.data.search_pro", res.data.search_pro);

          setTimeSlotArr(res.data.time_slot);
          setCommunicationModeArr(res.data.communication_mode);

          setResponseAfterSubmit(res.data.message);
          setResponceMsg(res.data.message)
          handleCloseOnlyResBox();
        },
        (res) => {
          setResponseAfterSubmit(res.data.message);
          setResponceMsg(res.data.message)
          setBackDropLoaderResp(false);
          setErrBackDropLoaderResp(true);

          setTimeout(() => {
            setErrBackDropLoaderResp(false);
          }, 2500);
        }
      )
    );
  }

  function handleBack() {
    if (
      // catId === undefined &&

      prodTypeId === undefined &&
      brandId === undefined
    ) {
      getMediaStream();
      setShowFeedback(false);
      setCanvasEnabled(false);
    }

    if (
      catId !== undefined &&
      prodTypeId === undefined &&
      brandId === undefined
    ) {
      setCatId(undefined);
      setBreadCatName("");
      setBreadCatButtonName("");
      setLabelName("Category");
    }

    if (
      catId !== undefined &&
      prodTypeId !== undefined &&
      brandId === undefined
    ) {
      setProdTypeId(undefined);
      setBreadProductName("");
      setLabelName("Product Type");
    }
    if (
      catId !== undefined &&
      prodTypeId !== undefined &&
      brandId !== undefined
    ) {
      setBrandId(undefined);
      setBreadBrandName("");
      setLabelName("Brand Name");
    }

    if (catId === -2 && prodTypeId === 0 && brandId === 0) {
      setLabelName("Category");
      setBrandId(undefined);
      setProdTypeId(undefined);

      setCatId(undefined);
    }

    if (catId !== undefined && prodTypeId === -2 && brandId === 0) {
      setLabelName("Product Type");
      setBrandId(undefined);
      setProdTypeId(undefined);
    }
  }

  // Here all Payment module integration

  const [paymentModal, setPaymentModal] = useState(false);
  const [cardInfo, setCardInfo] = useState({
    cardNumber: "",
    expiryDate: "",
    cvc: "",
    cardHolder: "",
    focus: "",
  });
  const [isCardHolderNameErr, setIsCardHolderNameErr] = useState(false);
  const [isCardNumberErr, setIsCardNumberErr] = useState(false);
  const [isCardExpErr, setIsCardExpErr] = useState(false);
  const [isCardCVCErr, setIsCardCVCErr] = useState(false);

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState("");
  const [handleToaster, setHandleToaster] = useState(false);
  const [apiResponce, setApiResponse] = useState(false);

  const handleCardNumberChange = (e) => {
    setIsCardNumberErr(false);
    // Remove anything that's not a digit
    const newValue = e.target.value.replace(/\D/g, "");

    // Add spaces after every 4 digits for display
    const formattedValue = newValue.replace(/(\d{4})/g, "$1 ").trim();

    // Update the actual input value
    e.target.value = formattedValue;

    setFormatedNumber(formattedValue);

    // Update state without spaces
    setCardInfo({
      ...cardInfo,
      cardNumber: newValue,
    });
  };

  const handleExpiryDateChange = (e) => {
    setIsCardExpErr(false);
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 4) value = value.substr(0, 4); // Maximum length of 4 digits
    if (value.length > 2) value = value.substr(0, 2) + "/" + value.substr(2); // Insert slash after two digits

    setCardInfo({
      ...cardInfo,
      expiryDate: value,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "cardHolder") {
      setIsCardHolderNameErr(false);
    }

    setCardInfo({
      ...cardInfo,
      [name]: value,
    });
  };

  const handleCVCChange = (e) => {
    setIsCardCVCErr(false);
    const newValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
    setCardInfo({
      ...cardInfo,
      cvc: newValue,
    });
  };

  const handleInputFocus = (e) => {
    const { name } = e.target;
    setCardInfo({
      ...cardInfo,
      focus: name,
    });
  };

  const handleCardHolderNameBlurCheck = () => {
    if (cardInfo.cardHolder.trim() === "") {
      setIsCardHolderNameErr(true);
    }
  };

  const handleCardNumberBlurCheck = () => {
    // console.log(!validateCardNumber(Number(cardInfo.cardNumber)))
    // console.log(cardInfo.cardNumber, typeof cardInfo.cardNumber, 'handleCardNumberBlurCheck')

    const cardType = creditCardType(cardInfo.cardNumber);
    // console.log(cardType, 'cardType')

    if (
      cardInfo.cardNumber.length !== 16 ||
      cardType.length === 0
      // || !validator.isCreditCard(cardInfo.cardNumber)
    ) {
      setIsCardNumberErr(true);
    }
  };

  const handleCardExpBlurCheck = () => {
    const [month, year] = cardInfo.expiryDate.split("/");
    if (
      cardInfo.expiryDate.trim() === "" ||
      cardInfo.expiryDate.trim().length != 5 ||
      Number(month) > 12 ||
      Number(year) < Number(new Date().getFullYear().toString().slice(-2))
    ) {
      setIsCardExpErr(true);
    }
  };

  const handleCardCVCBlurCheck = () => {
    if (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "") {
      setIsCardCVCErr(true);
    }
  };

  const handleSubmitPay = (e) => {
    e.preventDefault();
    setApiResponse(true);
    const [month, year] = cardInfo.expiryDate.split("/");
    if (cardInfo.cardHolder.trim() === "") {
      setIsCardHolderNameErr(true);
      setApiResponse(false);
    }
    const cardType = creditCardType(cardInfo.cardNumber);

    if (
      cardInfo.cardNumber.length !== 16 ||
      cardType.length === 0
      // || !validator.isCreditCard(cardInfo.cardNumber)
    ) {
      setIsCardNumberErr(true);
    }
    if (
      cardInfo.expiryDate.trim() === "" ||
      Number(month) > 12 ||
      Number(year) < Number(new Date().getFullYear().toString().slice(-2))
    ) {
      setIsCardExpErr(true);
      setApiResponse(false);
    }
    if (cardInfo.cvc.length !== 3 || cardInfo.cvc.trim() === "") {
      setIsCardCVCErr(true);
      setApiResponse(false);
    }

    if (
      cardInfo.cardHolder.trim() === "" ||
      cardInfo.cardNumber.length !== 16 ||
      cardType.length === 0 ||
      //  !validator.isCreditCard(cardInfo.cardNumber) ||
      cardInfo.expiryDate.trim() === "" ||
      cardInfo.expiryDate.trim().length != 5 ||
      Number(month) > 12 ||
      Number(year) < Number(new Date().getFullYear().toString().slice(-2)) ||
      cardInfo.cvc.length !== 3 ||
      cardInfo.cvc.trim() === ""
    ) {
      setApiResponse(false);
      return;
    }

    if (
      !isCardHolderNameErr &&
      !isCardNumberErr &&
      !isCardExpErr &&
      !isCardCVCErr
    ) {
      // Here you can handle the submission of the credit card information.
      // You would typically send this to a server that can process the payment using a third-party payment processor.

      let details = new FormData();

      details.append("user_id_ids", localStorage.getItem("user_id"));
      details.append("name_on_card", cardInfo.cardHolder);
      details.append("card_number", parseInt(cardInfo.cardNumber));
      details.append("expiry_month", parseInt(month));
      details.append("expiry_year", parseInt(year));
      details.append("card_cvc_number", parseInt(cardInfo.cvc));
      details.append("token_chr", "tok_visa");

      dispatch(
        createPaymentMethod(
          details,
          (res) => {
            // console.log(res)
            setApiResponse(false);
            setPaymentModal(false);
            setResponceMsg(res.data.message);
            setToasterType("success");

            let details = {
              user_id_ids: localStorage.getItem("user_id"),
              role_id_int: localStorage.getItem("roleId"),
              user_impersonate_flag: 0,
            };
            dispatch(
              userById(details, (res) => {
                dispatch(setUserDetails(res.data.data));
              })
            );
            submitFeedback();

            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 11000);
          },
          (res) => {
            // console.log(res)
            setResponceMsg(res.data.message);
            setToasterType("error");

            setApiResponse(false);
            setPaymentModal(false);

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  };

  const handleConfirmPay = () => {
    setPaymentModal(false);
    submitFeedback();
  };

  // Handle Update credit card details

  const [cardArr, setCardArr] = useState([]);
  const [particularCard, setParticularCard] = useState({});

  // console.log(cardArr, "cardArr");

  const setInitialCardDetails = (res) => {
    res.data && setCardArr(res.data);
  };

  const [updateCardTrigger, setUpdateCardTrigger] = useState(false);
  const handleCloseUpdateCard = () => {
    setUpdateCardTrigger(false);
    getPaymentMethodList();
  };
  const handleOpenUpdateCard = (element, isPrimaryCard) => {
    setUpdateCardTrigger(true);
    if (isPrimaryCard) {
      setParticularCard(cardArr?.[cardArr?.length - 1]);
    } else {
      setParticularCard(element);
    }
  };

  // Add new card modal functions
  const [addNewCardTrigger, setAddNewCardTrigger] = useState(false);
  const handleCloseAddNewCard = () => {
    setAddNewCardTrigger(false);
    getPaymentMethodList();
    setPaymentConfirmModal(true);
  };
  const handleOpenAddNewCard = () => {
    setAddNewCardTrigger(true);
  };

  // Set default payment method
  const selectPrimaryCardFn = (e, element) => {
    e.preventDefault();
    setPrimaryCardLoading(true);
    let details = new FormData();

    details.append("payment_method_id", element.id);
    details.append("user_id_ids", localStorage.getItem("user_id"));

    dispatch(
      setDefaultPaymentMethodById(
        details,
        (res) => {
          // console.log(res)
          setPrimaryCardLoading(false);
          setResponceMsg(res.data.message);
          setToasterType("success");

          getPaymentMethodList();
          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        },
        (res) => {
          // console.log(res)
          setResponceMsg(res.data.message);
          setToasterType("error");

          setPrimaryCardLoading(false);

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  useEffect(() => {
    if (customerID) {
      getPaymentMethodList();
    }
  }, []);

  useEffect(() => {
    if (!customerID) {
      const getCountryCode = async () => {
        try {
          const response = await axios.get('https://ipapi.co/json/');
          const data = response.data;
          // console.log(`'My country code:', ${data.country}`)
          setMyCountryCode(data.country);
        } catch (error) {
          console.log('Error fetching country code:', error);
        }
      };
      getCountryCode();
    }
  }, []);

  const getPaymentMethodList = (firstTimeID) => {
    let details = {
      customer_id_ids: customerID || firstTimeID,
    };
    dispatch(
      getPaymentMethodListByCustomerId(
        details,
        (res) => {
          // console.log(res.data.data)
          setInitialCardDetails(res?.data?.data);
        },
        (res) => {
          // console.log(res.data.data)
        }
      )
    );
  };

  // Handle to identify the manual  selection by user
  const handleManualSelection = () => {
    setShowFeedback(true);
  };

  const [scanImageCheck, setScanImageCheck] = useState(false);

  const uploadPicRef = useRef();
  const handleClickUploadPicture = () => {
    uploadPicRef.current.click();
  };
  const [productTypeList, setProductTypeList] = useState([]);
  const handleUploadPicture = async (e) => {
    if (e.target.files) {
      setResponseBox(true)
      setLoading(true);
      setImage(e.target.files[0]);

      handleScanSteps(2);

      // setShowFeedback(true);

      // const file = e.target.files[0];
      // if (file) {
      //   const reader = new FileReader();
      //   reader.onloadend = () => {
      //     console.log(reader.result);
      //   };
      //   reader.readAsDataURL(file);
      // }

      setScanImageCheck(true);

      let formData = new FormData();

      const file = e.target.files[0];

      if (file && file.size > 1024 * 1024) { // Check if the file size is greater than 1 MB
        try {
          const options = {
            maxSizeMB: 0.350, // Maximum size in MB
            maxWidthOrHeight: 1920, // Maximum width or height
            useWebWorker: true, // Use web worker for faster compression
          };
          const compressedFile = await imageCompression(file, options);
          // console.log('Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
          // console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
          // setUploadAttachedImage0(compressedFile);
          // setAttachedImage0(URL.createObjectURL(compressedFile))

          formData.append("image", compressedFile, "scanned_image.png");

          dispatch(
            RecogObj(
              formData,
              (res) => {

                setCanvasEnabled(false);
                setLoading(false);
                setResValue(res.data.message);
                clearValue();
                setIsResValue(true);
                setObjectCategoryName(res.data.data.predicted_object_category);
                setPredictionFlag(res.data.data.prediction_flag);
                setPredictedObjectClassId(
                  res.data.data.predicted_object_class_id_ids
                );
                setPredictedObjectClassName(res.data.data.predicted_object_name);
                setProductTypeDetected(res.data.data.predicted_object_name);
                setPredictedLogId(res.data.data.prediction_logs_id);
                setProductTypeList(res.data.data.product_type_list);

                setDeviceColorChr(res.data.data.device_color);
                setDeviceBrandChr(res.data.data.predicted_object_brand);

                setModelNum(res.data.data.predicted_object_model_number);
                setSerialNumber(res.data.data.predicted_object_serial_number);

                setObjectCondition(res.data.data.predicted_object_condition);

                setPredictedObjectDetails(res?.data?.data);

                handleScanSteps(3);
              },
              () => {
                setLoading(false);
              }
            )
          );
        } catch (error) {
          console.error('Error compressing the image:', error);
        }
      } else {
        // setUploadAttachedImage0(file);
        // setAttachedImage0(URL.createObjectURL(file));
        formData.append("image", file, "scanned_image.png");

        dispatch(
          RecogObj(
            formData,
            (res) => {

              setCanvasEnabled(false);
              setLoading(false);
              setResValue(res.data.message);
              clearValue();
              setIsResValue(true);
              setObjectCategoryName(res.data.data.predicted_object_category);
              setPredictionFlag(res.data.data.prediction_flag);
              setPredictedObjectClassId(
                res.data.data.predicted_object_class_id_ids
              );
              setPredictedObjectClassName(res.data.data.predicted_object_name);
              setProductTypeDetected(res.data.data.predicted_object_name);
              setPredictedLogId(res.data.data.prediction_logs_id);
              setProductTypeList(res.data.data.product_type_list);

              setDeviceColorChr(res.data.data.device_color);
              setDeviceBrandChr(res.data.data.predicted_object_brand);

              setModelNum(res.data.data.predicted_object_model_number);
              setSerialNumber(res.data.data.predicted_object_serial_number);

              setObjectCondition(res.data.data.predicted_object_condition);

              setPredictedObjectDetails(res?.data?.data);

              handleScanSteps(3);
            },
            () => {
              setLoading(false);
            }
          )
        );
      }
    }
  };


  useEffect(() => {
    if (prodTypeArr.length > 0) {
      setProductTypeList(prodTypeArr);
    }
  }, [prodTypeArr]);

  // Scheduling start here ----------
  const [dateTime, setDateTime] = useState("");
  const [unixTimestamp, setUnixTimestamp] = useState("");
  const [unixEndTime, setUnixEndTime] = useState("");
  const [isDateTimeErr, setIsDateTimeErr] = useState(false);
  const [scheduleLoader, setScheduleLoader] = useState(false);

  const handleDateTime = (e) => {
    setIsDateTimeErr(false);
    const newDateTime = e.target.value;

    setDateTime(newDateTime);
    // console.log(e.target.value);

    // Convert the input value to a Unix timestamp
    const timestamp = new Date(newDateTime).getTime() / 1000;
    setUnixTimestamp(Math.floor(timestamp));
    // console.log(Math.floor(timestamp), "Start timestamp");

    // Calculate the end time by adding one hour (3600 seconds)
    const endTimeStamp = Math.floor(timestamp) + 3600;
    setUnixEndTime(endTimeStamp);
    // console.log(endTimeStamp, "End timestamp");
  };

  // Modal functions for the date time confirmation
  const [scheduleModalTrigger, setScheduleModalTrigger] = React.useState(false);
  const handleOpenScheduleModal = () => {
    setScheduleModalTrigger(true);
    handleCloseOnlyResBox();
  };

  const handleCloseDocScheduleModal = () => {
    setScheduleModalTrigger(false);
    setIsDateTimeErr(false);
    handleClearSchedule();
    setResponseBox(true);
  };

  const handleClearSchedule = () => {
    setDateTime("");
    setUnixTimestamp("");
    setUnixEndTime("");
  };

  // New functions for the Schedule call
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    handleSetCurrentDateAndTime();
  }, []);

  // const handleSetCurrentDateAndTime = () => {
  //   // Get the current date and time
  //   const now = new Date();
  //   const date = now.toISOString().split("T")[0]; // format yyyy-mm-dd for the date input

  //   // Set the time one hour ahead, format hh:mm for the time input
  //   now.setHours(now.getHours() + 1);
  //   let hours = now.getHours();
  //   let minutes = now.getMinutes();
  //   // Ensure two-digit formatting for hours and minutes
  //   hours = hours < 10 ? `0${hours}` : hours;
  //   minutes = minutes < 10 ? `0${minutes}` : minutes;
  //   const time = `${hours}:${minutes}`;

  //   // Update the state
  //   setCurrentDate(date);
  //   setCurrentTime(time);
  // };

  // console.log(currentDate, "Date");
  // console.log(currentTime, "Time");

  const handleSetCurrentDateAndTime = () => {
    // Get the current date and time
    const now = new Date();
    const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

    // Set the time one hour ahead
    now.setHours(now.getHours() + 1);

    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Adjust minutes to the nearest 30-minute slot
    minutes = minutes < 30 ? 0 : 30;

    // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
    if (minutes === 0 && now.getMinutes() >= 30) {
      hours += 1;
    }

    // Ensure two-digit formatting for hours and minutes
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes === 0 ? `00` : `30`;

    const time = `${hours}:${minutes}`;

    // Update the state
    setCurrentDate(date);
    setCurrentTime(time);
  };

  const handleTimeChange = (e) => {
    const value = e.target.value;
    const [hours, minutes] = value.split(':').map(Number);

    // Adjust minutes to nearest valid option (0 or 30)
    const validMinutes = minutes < 15 ? '00' : '30';

    const correctedTime = `${hours.toString().padStart(2, '0')}:${validMinutes}`;
    setCurrentTime(correctedTime);
  };

  const convertToUnixTime = () => {
    // Combine the date and time into a single Date object
    const combinedDateTime = new Date(`${currentDate}T${currentTime}`);
    // Convert to Unix timestamp
    return Math.floor(combinedDateTime.getTime() / 1000);
  };

  const calculateEndTime = (unixTime) => {
    // Adding 3600 seconds (1 hour) to the current unix timestamp
    return unixTime + 3600;
  };

  const handleSubmitSchedule = () => {
    // console.log(dateTime, unixTimestamp, unixEndTime);
    setScheduleLoader(true);

    const startTimeUnix = convertToUnixTime();
    const endTimeUnix = calculateEndTime(startTimeUnix);

    let createTicketData = new FormData();

    createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
    // createTicketData.append("address_id_ids",0)
    //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
    // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
    createTicketData.append(
      "object_name_chr",
      productNameForTicket ? productNameForTicket : productTypeDetected
    );

    createTicketData.append("object_category_chr", objectCategoryName);
    modelNum && createTicketData.append("object_model_number_chr", modelNum);
    serialNumber && createTicketData.append("serial_number_chr", serialNumber);
    description &&
      createTicketData.append("problem_description_chr", description);
    deviceBrandChr &&
      createTicketData.append("device_brand_chr", deviceBrandChr);
    deviceColorChr &&
      createTicketData.append("device_color_chr", deviceColorChr);
    image &&
      createTicketData.append(
        "attachment0",
        image,
        "uploadAttachedImage0.jpeg"
      );
    uploadAttachedImage1 != null &&
      createTicketData.append(
        "attachment1",
        uploadAttachedImage1,
        "uploadAttachedImage1.jpeg"
      );
    uploadAttachedImage2 != null &&
      createTicketData.append(
        "attachment2",
        uploadAttachedImage2,
        "uploadAttachedImage2.jpeg"
      );

    createTicketData.append("is_scheduling_flag", 1);
    createTicketData.append("unix_datetime_stamp_start", startTimeUnix);
    createTicketData.append("unix_datetime_stamp_end", endTimeUnix);

    createTicketData.append(
      "amount_after_discount",
      finalAmountAfterPromoCodeApplied
    );

    isCreditsUsed && createTicketData.append("use_credits_flag", isCreditsUsed);

    verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);

    qrResult && createTicketData.append("qr_info_chr", qrResult);
    objectCondition && createTicketData.append("condition_chr", objectCondition);

    DIYProjectId && createTicketData.append("project_id_ids", DIYProjectId);

    verifiedPromoCode && localStorage.getItem("isFreeSR") && createTicketData.append("is_free_sr", localStorage.getItem("isFreeSR") ? localStorage.getItem("isFreeSR") : 0);
    createTicketData.append("ticket_type", 1);

    let summary_meta_data = {
      recognized_image_summary: predictedObjectDetails?.predicted_object_info?.recognized_image_summary || '',
      recognized_estimation_summary: predictedObjectDetails?.predicted_object_info?.recognized_estimation_summary || '',
      recognized_repair_and_install_summary: predictedObjectDetails?.predicted_object_info?.recognized_repair_and_install_summary || '',
    }
    createTicketData.append("summary", JSON.stringify(summary_meta_data));

    dispatch(
      CreateTicket(
        createTicketData,
        (res) => {
          // localStorage.setItem("triggerFlag", 1);
          // localStorage.setItem("roomCode", res.data.data.room_id);
          // localStorage.setItem("call_log_id",res.data.data.room_id)
          // navigate("/videoCall")
          // console.log(res)
          handleCloseDocScheduleModal();

          handleOpenScheduleSuccess();

          setResponseBox(false);

          localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
          localStorage.setItem("proType", res.data.data.product_type_chr);
          setScheduleLoader(false);

          localStorage.getItem("isFreeSR") && localStorage.removeItem("isFreeSR");
          localStorage.getItem("proCode") && localStorage.removeItem("proCode");


          setResponceMsg(res.data.message);
          setToasterType("success");
          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        },
        (err) => {
          // console.log(err)

          setScheduleLoader(false);

          setResponceMsg(err.data.message);
          setToasterType("error");
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

        }
      )
    );
  };
  // Scheduling ends here -----------

  // Response modal after scheduling service request
  const [responseScheduleSuccess, setResponseScheduleSuccess] = useState(false);
  const handleOpenScheduleSuccess = () => {
    setResponseScheduleSuccess(true);
  };
  const handleCloseScheduleSuccess = () => {
    setResponseScheduleSuccess(false);
    navigate("/serviceRequest");
  };

  const [scanSteps, setScanSteps] = useState(1);
  const handleScanSteps = (step) => {
    setScanSteps(step);
  };

  useEffect(() => {
    if (!responseBox) {
      setScanSteps(1);
    }
  }, [responseBox]);

  // Horizontal Scroll for navbar functions
  const [isScrolling, setIsScrolling] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const navbarRef = useRef(null);

  const onMouseDown = (e) => {
    setIsScrolling(true);
    setStartX(e.pageX - navbarRef.current.offsetLeft);
    setScrollLeft(navbarRef.current.scrollLeft);
  };

  const onMouseLeave = () => {
    setIsScrolling(false);
  };

  const onMouseUp = () => {
    setIsScrolling(false);
  };

  const onMouseMove = (e) => {
    if (!isScrolling) return;
    e.preventDefault();
    const x = e.pageX - navbarRef.current.offsetLeft;
    const walk = (x - startX) * 2; // The multiplier 2 determines the scroll speed
    navbarRef.current.scrollLeft = scrollLeft - walk;
  };

  const [productType, setProductType] = useState("");

  const clearProductType = (e) => {
    e.stopPropagation();
    setProductType("");
    setProdTypeId();
    setProductTypeDetected("");
  };

  // Functions for the OCR
  const [ocrModalTrigger, setOcrModalTrigger] = useState(false);
  const handleOpenOcrModal = () => {
    setOcrModalTrigger(true);
    setResponseBox(false);
  };
  const handleCloseOcrModal = () => {
    setOcrModalTrigger(false);
    setResponseBox(true);
    stopCameraOcr();
  };

  const videoRefOcr = useRef(null);
  const canvasRefOcr = useRef(null);
  const [streamOcr, setStreamOcr] = useState(null);
  const [imageForOcr, setImageForOcr] = useState(null);
  const [capturedImage, setCapturedImage] = useState("");
  const [ocrLoading, setOcrLoading] = useState(false);

  // console.log(imageForOcr, 'imageForOcr')

  // Access the device camera
  const startCameraOcr = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "envoronment" },
      });
      setStreamOcr(mediaStream);
      if (videoRefOcr.current) {
        videoRefOcr.current.srcObject = mediaStream;
      }
    } catch (error) {
      console.error("Error accessing the camera", error);
    }
  };

  // Stop the camera by stopping all tracks on the stream
  const stopCameraOcr = () => {
    if (streamOcr) {
      streamOcr.getTracks().forEach((track) => track.stop());
      setStreamOcr(null); // Update the state to reflect that the stream has been stopped
    }
  };

  // Capture the image
  const captureImageOcr = () => {
    if (canvasRefOcr.current && videoRefOcr.current) {
      canvasRefOcr.current.width = videoRefOcr.current.videoWidth;
      canvasRefOcr.current.height = videoRefOcr.current.videoHeight;

      const context = canvasRefOcr.current.getContext("2d");
      context.drawImage(
        videoRefOcr.current,
        0,
        0,
        canvasRefOcr.current.width,
        canvasRefOcr.current.height
      );
      const imageUrl = canvasRefOcr.current.toDataURL("image/jpeg");
      setCapturedImage(imageUrl); // Save the captured image's data URL to state

      canvasRefOcr.current.toBlob(
        (blob) => {
          // sendImageToAPI(blob);
          setImageForOcr(blob);
          handleOcr(blob);
        },
        "image/jpeg",
        0.95
      ); // Adjust image format and quality as needed
    }
  };

  const handleOcr = (blob) => {
    setOcrLoading(true);

    let formData = new FormData();

    formData.append("image", blob);

    dispatch(
      ocr(
        formData,
        (res) => {
          // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
          setOcrLoading(false);

          res?.data?.data?.predicted_object_model_number && setModelNum(res?.data?.data?.predicted_object_model_number);
          res?.data?.data?.predicted_object_serial_number && setSerialNumber(res?.data?.data?.predicted_object_serial_number);
          res?.data?.data?.predicted_object_brand && setDeviceBrandChr(res?.data?.data?.predicted_object_brand);

          handleCloseOcrModal();

          if (!res?.data?.data?.predicted_object_model_number) {
            setResponceMsg(
              "Model number not recognized, please try again or enter manually."
            );
            setToasterType("info");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        },
        (res) => {
          // console.log(res);
          setOcrLoading(false);

          setResponceMsg(res.data.message);
          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  const handleModelNum = (e) => {
    setModelNum(e.target.value);
  };
  const handleSerialNumber = (e) => {
    setSerialNumber(e.target.value);
  };
  const handleDeviceBrandChr = (e) => {
    setDeviceBrandChr(e.target.value);
  };

  // New Payments methods functions starts here
  const [paymentGatewayFlag, setPaymentGatewayFlag] = useState(0);
  const [callChargeAmount, setCallChargeAmount] = useState(0);
  const [callDurationTimeLimit, setCallDurationTimeLimit] = useState(0);
  const [callChargeDescription, setCallChargeDescription] = useState("");
  const [toggleCardsMenu, setToggleCardsMenu] = useState(false);

  const getPaymentConfigFn = () => {
    let details = {};
    dispatch(
      getPaymentConfigApi(
        details,
        (res) => {
          // console.log(res.data.data)
          // console.log(res?.data?.data)
          setPaymentGatewayFlag(
            res?.data?.data?.purchase?.payment_gateway_flag
          );
          setCallChargeAmount(
            res?.data?.data?.purchase?.call_charge_amount_in_cents_int / 100
          );
          setCallDurationTimeLimit(
            res?.data?.data?.purchase?.call_duration_time_limit_in_sec / 60
          );
          setCallChargeDescription(
            res?.data?.data?.purchase?.call_charge_description_chr
          );
        },
        (res) => {
          // console.log(res.data.data);
        }
      )
    );
  };

  // console.log(paymentGatewayFlag, 'paymentGatewayFlag', callChargeAmount, '$ callChargeAmount', callDurationTimeLimit, 'min callDurationTimeLimit')

  // Payment are hide for the new service flow 
  // useEffect(() => {
  //   getPaymentConfigFn();
  // }, []);

  useEffect(() => {
    setFinalAmountAfterPromoCodeApplied(callChargeAmount);
  }, [callChargeAmount])

  useEffect(() => {
    if (isCreditsUsed) {
      setFinalAmountAfterPromoCodeApplied(0);
    } else {
      setFinalAmountAfterPromoCodeApplied(callChargeAmount);
    }
    handleClearPromocodeStates();
  }, [isCreditsUsed])

  // Payment confirm modal functions
  const [paymentConfirmModal, setPaymentConfirmModal] = useState(false);
  const [isPaymentMethodErr, setIsPaymentMethodErr] = useState(false);
  const [primaryCardLoading, setPrimaryCardLoading] = useState(false);

  const handleOpenPaymentModalTrigger = (element) => {
    setPaymentConfirmModal(true);
    setResponseBox(false);
    setScheduleModalTrigger(false);
  };

  const handleClosePaymentModalTrigger = () => {
    setResponseBox(true);
    setPaymentConfirmModal(false);
    handleClearPromocodeStates();
    setIsScheduledCall(false);
    setIsCreditsUsed(false);
  };

  const handleClearPromocodeStates = () => {
    setIsPromoCodeErr(false);
    setIsPaymentMethodErr(false);
    setPromoCode("");
    setVerifiedPromoCode("");
    setPromoCodeRes({});
    // setFinalAmountAfterPromoCodeApplied(0);
  }

  // Check promocode functions
  const [promoCode, setPromoCode] = useState("");
  const [verifiedPromoCode, setVerifiedPromoCode] = useState("");
  const [isPromoCodeErr, setIsPromoCodeErr] = useState(false);
  const [promoCodeLoading, setPromoCodeLoading] = useState(false);
  const [finalAmountAfterPromoCodeApplied, setFinalAmountAfterPromoCodeApplied] = useState(0);
  const [promoCodeRes, setPromoCodeRes] = useState({});

  // console.log(promoCode, 'promoCode')

  const handlePromoCode = (e) => {
    setIsPromoCodeErr(false);
    setIsPaymentMethodErr(false);
    setPromoCode(e.target.value);
  };

  const handlePromoCodeBlurCheck = () => {
    if (promoCode === "") {
      setIsPromoCodeErr(false);
    }
  };

  const handleCheckPromoCodeFn = (proCode) => {
    setPromoCodeLoading(true);

    let data = {
      promo_code_chr: promoCode || proCode,
      type_chr: "CALL",
      user_id_ids: localStorage.getItem("user_id"),
      is_free_sr: localStorage.getItem("isFreeSR") ? localStorage.getItem("isFreeSR") : 0,
      //  product_id_chr: productId,
    };

    dispatch(
      checkPromoCode(
        data,
        (res) => {
          // console.log(res)
          setPromoCodeRes(res.data.data);
          setVerifiedPromoCode(promoCode || proCode);

          setFinalAmountAfterPromoCodeApplied(
            res?.data?.data
              ?.amount_to_be_charged_for_a_call_in_dollars_after_discount
          );
          // console.log(res?.data?.data?.amount_to_be_charged_for_a_subscription_in_dollars_after_discount, "final amoubt")
          setIsPromoCodeErr(false);
          setPromoCodeLoading(false);
          setResponceMsg(res.data.message);
          setToasterType("success");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        },
        (res) => {
          // console.log(res)
          setIsPromoCodeErr(true);
          setPromoCodeLoading(false);
          setPromoCodeRes({});

          setVerifiedPromoCode('');
          setFinalAmountAfterPromoCodeApplied(callChargeAmount);
          // setResponceMsg(res.data.message)
          // setToasterType("error");

          // setHandleToaster(true);
          // setTimeout(() => {
          //     setHandleToaster(false);
          // }, 11000);
        }
      )
    );
  };

  useEffect(() => {
    if (localStorage.getItem("proCode")) {
      setPromoCode(localStorage.getItem("proCode"));

      handleCheckPromoCodeFn(localStorage.getItem("proCode"));
    }

  }, [localStorage.getItem("proCode")])

  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  // Get payment method list functions
  const [supportedPaymentMethodsArr, setSupportedPaymentMethodsArr] = useState(
    []
  );
  const [
    customLoadingForSupportedMethods,
    setCustomLoadingForSupportedMethods,
  ] = useState(false);
  const [getSupportedPaymentFlag, setGetSupportedPaymentFlag] = useState(false);

  // Add new Payment method modal functions
  const [addNewPaymentMethodTrigger, setAddNewPaymentMethodTrigger] =
    useState(false);
  const handleCloseAddNewPaymentMethod = () => {
    setAddNewPaymentMethodTrigger(false);
    // handleClearCardStates();
  };
  const handleOpenAddNewPaymentMethod = () => {
    setAddNewPaymentMethodTrigger(true);
    // setGetSupportedPaymentFlag(true);
    // handleClosePaymentModalTrigger();
    getPaymentMethodSupportedListFn();
    setPaymentConfirmModal(false);
  };

  const getPaymentMethodSupportedListFn = () => {
    let details = {};
    setCustomLoadingForSupportedMethods(true);
    dispatch(
      getPaymentMethodSupportedList(
        details,
        (res) => {
          // console.log(res.data.data)
          // console.log(res?.data?.data)
          setSupportedPaymentMethodsArr(res?.data?.data);
          setCustomLoadingForSupportedMethods(false);
        },
        (res) => {
          // console.log(res.data.data)
          setCustomLoadingForSupportedMethods(false);
        }
      )
    );
  };

  useEffect(() => {
    if (getSupportedPaymentFlag) {
      getPaymentMethodSupportedListFn();
    }
  }, [getSupportedPaymentFlag]);

  // Add new card first time functions
  // Add new card modal functions
  const [formatedNumber, setFormatedNumber] = useState("");
  const [addCardFirstTimeTrigger, setAddCardFirstTimeTrigger] = useState(false);
  const handleCloseAddCardFirstTime = () => {
    setAddCardFirstTimeTrigger(false);
    handleClearCardStates();
    setPaymentConfirmModal(true);
  };
  const handleOpenAddCardFirstTime = () => {
    setAddCardFirstTimeTrigger(true);
  };

  const handleClearCardStates = () => {
    setCardInfo({
      cardNumber: "",
      expiryDate: "",
      cvc: "",
      cardHolder: "",
      focus: "",
    });
    setFormatedNumber("");
    setIsCardHolderNameErr(false);
    setIsCardNumberErr(false);
    setIsCardExpErr(false);
    setIsCardCVCErr(false);

    setCardCvcError('')
    setCardExpiryError('')
    setCardNumberError('')

    setZipCode('')
    setIsZipCodeErr(false)
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setApiResponse(true);
    const [month, year] = cardInfo.expiryDate.split("/");
    if (cardInfo.cardHolder.trim() === "") {
      setIsCardHolderNameErr(true);
      setApiResponse(false);
    }
    const cardType = creditCardType(cardInfo.cardNumber);

    if (
      cardInfo?.cardNumber?.length !== 16 ||
      cardType?.length === 0
      // || !validator.isCreditCard(cardInfo.cardNumber)
    ) {
      setIsCardNumberErr(true);
    }
    if (
      cardInfo.expiryDate.trim() === "" ||
      cardInfo?.expiryDate?.trim()?.length != 5 ||
      Number(month) > 12 ||
      Number(year) < Number(new Date().getFullYear().toString().slice(-2))
    ) {
      setIsCardExpErr(true);
      setApiResponse(false);
    }
    if (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "") {
      setIsCardCVCErr(true);
      setApiResponse(false);
    }

    if (
      cardInfo?.cardHolder?.trim() === "" ||
      cardInfo?.cardNumber?.length !== 16 ||
      cardType?.length === 0 ||
      // !validator.isCreditCard(cardInfo.cardNumber) ||
      cardInfo.expiryDate.trim() === "" ||
      cardInfo?.expiryDate?.trim()?.length != 5 ||
      Number(month) > 12 ||
      Number(year) < Number(new Date().getFullYear().toString().slice(-2)) ||
      cardInfo?.cvc?.length < 3 ||
      cardInfo?.cvc?.trim() === ""
    ) {
      setApiResponse(false);
      return;
    }

    if (
      !isCardHolderNameErr &&
      !isCardNumberErr &&
      !isCardExpErr &&
      !isCardCVCErr
    ) {
      // Here you can handle the submission of the credit card information.

      let details = new FormData();

      details.append("user_id_ids", localStorage.getItem("user_id"));
      details.append("name_on_card", cardInfo.cardHolder);
      details.append("card_number", parseInt(cardInfo.cardNumber));
      details.append("expiry_month", parseInt(month));
      details.append("expiry_year", parseInt(year));
      details.append("card_cvc_number", parseInt(cardInfo.cvc));
      details.append("token_chr", "tok_visa");

      dispatch(
        createPaymentMethod(
          details,
          (res) => {
            // console.log(res)
            setApiResponse(false);
            setResponceMsg(res.data.message);
            setToasterType("success");
            handleCloseAddCardFirstTime();

            getPaymentMethodList(res?.data?.data?.customer?.id);

            let details = {
              user_id_ids: localStorage.getItem("user_id"),
              role_id_int: localStorage.getItem("roleId"),
              user_impersonate_flag: 0,
            };
            dispatch(
              userById(details, (res) => {
                dispatch(setUserDetails(res.data.data));
              })
            );

            setPaymentConfirmModal(true);

            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 11000);
          },
          (res) => {
            // console.log(res)
            setResponceMsg(res.data.message);
            setToasterType("error");

            setApiResponse(false);

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  };

  const handlePaymentConfirmation = () => {

    if (isCreditsUsed) {
      handleClearPromocodeStates();
      setPaymentConfirmModal(false);
      setIsCreditsUsed(false);

      if (isScheduledCall) {
        handleSubmitSchedule();
      } else {
        submitFeedback();
      }

    } else {
      // Condition if paid subscritption and no promocode
      if (cardArr?.length == 0 && !verifiedPromoCode) {
        setIsPaymentMethodErr(true);
        return;
      }

      // Condition if paid subscritption and promocode with 100% discount
      if (
        cardArr?.length == 0 &&
        verifiedPromoCode &&
        finalAmountAfterPromoCodeApplied != 0
      ) {
        setIsPaymentMethodErr(true);
        return;
      }

      handleClearPromocodeStates();
      setPaymentConfirmModal(false);

      if (isScheduledCall) {
        handleSubmitSchedule();
      } else {
        submitFeedback();
      }
    }


  };

  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? "am" : "pm";
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  // New calendar functions start here
  const [selectedDate, setSelectedDate] = useState(new Date()); // Initialize with current date or null

  const handleDateChange = (date) => {
    // Format the date when it is selected and log it or use it as needed
    const formattedDate = format(date, "yyyy-MM-dd");
    // console.log(formattedDate, "Formated date"); // Outputs the date in "2024-04-24" format
    setCurrentDate(formattedDate);
    setSelectedDate(date);
  };

  // console.log(currentDate, "Date current");
  // console.log(selectedDate, "selectDate here");
  const today = new Date();

  // Logic for the carousel
  const chunkSize = 3; // Number of items per slide
  const itemChunks = [];

  for (let i = 0; i < productTypeList.length; i += chunkSize) {
    itemChunks.push(productTypeList.slice(i, i + chunkSize));
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const lastIndex = productTypeList.length - 1;
    const shouldResetIndex = currentIndex === 0;
    const index = shouldResetIndex ? lastIndex : currentIndex - 1;
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    const lastIndex = productTypeList.length - 1;
    const shouldResetIndex = currentIndex === lastIndex;
    const index = shouldResetIndex ? 0 : currentIndex + 1;
    setCurrentIndex(index);
  };


  const stripe = useStripe();
  const elementsStripe = useElements();

  const handleSubmitStripe = async (event) => {
    event.preventDefault();
    setApiResponse(true);

    const isValidZipCode = validateZipCode();

    if (cardInfo.cardHolder.trim() === '' || !isValidZipCode) {
      if (cardInfo.cardHolder.trim() === '') {
        setIsCardHolderNameErr(true);
        setApiResponse(false);
      }

      // if (zipCode.trim() === '') {
      //   setIsZipCodeErr(true);
      //   setApiResponse(false);
      // }

    } else {
      if (!stripe || !elementsStripe) {
        // Ensure Stripe.js has loaded
        // console.log('Stripe has not loaded yet');
        setApiResponse(false);

        setResponceMsg('Stripe has not loaded yet')
        setToasterType("error");
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 2000);

        return;
      }

      // const cardElement = elements.getElement(CardElement);
      const cardElement = elementsStripe.getElement(CardNumberElement);


      // const cardNumberElement = elements.getElement(CardNumberInput);
      // const cardExpiryElement = elements.getElement(CardExpiryInput);
      // const cardCvcElement = elements.getElement(CardCvcInput);

      const { error, token } = await stripe.createToken(cardElement, {
        address_zip: zipCode,
      });

      if (error) {
        // console.log('Error:', error.message);
        setApiResponse(false);

        // setResponceMsg(error.message)
        // setToasterType("error");
        // setHandleToaster(true);
        // setTimeout(() => {
        //     setHandleToaster(false);
        // }, 2000);

      } else {
        // console.log('Success! Token: ', token);
        // console.log('Token created:', token.id);
        // You can now send the token to your server

        let details = new FormData();

        details.append("user_id_ids", localStorage.getItem("user_id"));
        details.append("name_on_card", cardInfo.cardHolder);
        details.append("token_chr", token.id);
        details.append("zip_code_chr", zipCode);
        details.append("country_code_chr", myCountryCode);

        setApiResponse(true);

        dispatch(
          createPaymentMethod(
            details,
            (res) => {
              // console.log(res)
              setApiResponse(false);

              setResponceMsg(res.data.message)
              setToasterType("success")

              handleCloseAddCardFirstTime();

              getPaymentMethodList(res?.data?.data?.customer?.id);

              let details = {
                user_id_ids: localStorage.getItem('user_id'),
                role_id_int: localStorage.getItem("roleId"),
                user_impersonate_flag: 0
              }
              dispatch(
                userById(details, (res) => {
                  dispatch(setUserDetails(res.data.data));
                }),
              )

              setPaymentConfirmModal(true);

              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (res) => {
              // console.log(res)
              setResponceMsg(res.data.message)
              setToasterType("error");

              setApiResponse(false);

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        )
      }
    }



  }

  const [cardNumberError, setCardNumberError] = useState('');
  const [cardExpiryError, setCardExpiryError] = useState('');
  const [cardCvcError, setCardCvcError] = useState('');

  const handleCardNumberChangeStripe = (event) => {
    // setCardNumberError(event.error ? event.error.message : '');
    setCardNumberError(event.error ? 'Enter valid card number' : '');
  };

  const handleCardExpiryChangeStripe = (event) => {
    // setCardExpiryError(event.error ? event.error.message : '');
    setCardExpiryError(event.error ? 'Enter valid exp. date' : '');

  };

  const handleCardCvcChangeStripe = (event) => {
    // setCardCvcError(event.error ? event.error.message : '');
    setCardCvcError(event.error ? 'Enter valid cvc' : '');
  };

  const [zipCode, setZipCode] = useState("");
  const [isZipCodeErr, setIsZipCodeErr] = useState(false);
  const handleZipCode = (e) => {
    setZipCode(e.target.value.replace(/\D/g, ''))
    setIsZipCodeErr(false)
  }

  const handleZipCodeBlurCheck = () => {
    // if (zipCode.trim() === '') {
    //   setIsZipCodeErr(true);
    // }

    validateZipCode()
  }

  const validateZipCode = () => {
    if (!zipCode) {
      setIsZipCodeErr(true);
      setApiResponse(false);
      return false;
    } else if (!isPostalCode(zipCode, myCountryCode || 'any')) {
      setIsZipCodeErr(true);
      setApiResponse(false);
      return false;
    }
    setIsZipCodeErr(false);
    return true;
  };

  // Sourcing the device info
  const [sourcingInfoModalTrigger, setSourcingInfoModalTrigger] = useState(false);
  const handleOpenSourcingInfoModal = () => {
    setSourcingInfoModalTrigger(true);
    handleCloseOnlyResBox();
  };

  const handleCloseSourcingInfoModal = () => {
    setSourcingInfoModalTrigger(false);
    setResponseBox(true);
  };

  const [sourcingInfoLoading, setSourcingInfoLoading] = useState(false);
  const [sourcingInfoArr, setSourcingInfoArr] = useState([]);
  const handleSourcingInfoFn = () => {
    setSourcingInfoLoading(true);

    let formData = new FormData();

    formData.append("product_type_chr", productNameForTicket ? productNameForTicket : productTypeDetected);
    formData.append("brand_name_chr", deviceBrandChr);
    formData.append("model_number_chr", modelNum);
    formData.append("product_manual_flag", 1);

    dispatch(
      sourcingInfoFromDeviceModelApi(
        formData,
        (res) => {
          // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
          setSourcingInfoLoading(false);
          // console.log(res?.data?.data?.manual, "here");
          const isArray = Array.isArray(res?.data?.data?.manual);
          isArray && setSourcingInfoArr(res?.data?.data?.manual);
        },
        (res) => {
          // console.log(res);
          setSourcingInfoLoading(false);

          setResponceMsg(res.data.message);
          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };
  const webcamRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(null);
  const canvasRef = useRef(null);
  const [crop, setCrop] = useState({ x: 100, y: 100, width: 200, height: 200 });
  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
  };



  const handleContinue = () => {
    if (canvasRef.current) {
      setResponseBox(true)
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      // Create a new canvas for the cropped area
      const croppedCanvas = document.createElement('canvas');
      croppedCanvas.width = crop.width;
      croppedCanvas.height = crop.height;
      const croppedCtx = croppedCanvas.getContext('2d');

      // Draw the cropped area from the original canvas onto the new canvas
      croppedCtx.drawImage(
        canvas,
        crop.x, crop.y, crop.width, crop.height,
        0, 0, crop.width, crop.height
      );
      setDisplayImage(croppedCanvas.toDataURL('image/jpeg'))
      // Get the cropped image data as a base64 string
      const croppedImageData = croppedCanvas.toDataURL('image/jpeg').replace("data:", "").replace(/^.+,/, "");

      // Convert the base64 string to a Blob
      const byteCharacters = atob(croppedImageData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'image/jpeg' });

      // Pass the blob back to the parent component or use it as needed
      // console.log(blob);  // For example, you could log it or upload it
      setResponseBox(true)
      setScanImageCheck(false);

      setLoading(true);
      setImage(blob);

      handleScanSteps(2);

      let formData = new FormData();

      formData.append("image", blob);

      dispatch(
        RecogObj(
          formData,
          (res) => {

            setCanvasEnabled(false);
            setLoading(false);
            setResValue(res.data.message);
            clearValue();
            setIsResValue(true);
            // setResponseBox(true);
            setObjectCategoryName(
              res.data.data.predicted_object_category
            );
            setPredictionFlag(res.data.data.prediction_flag);
            setPredictedObjectClassId(
              res.data.data.predicted_object_class_id_ids
            );
            setPredictedObjectClassName(
              res.data.data.predicted_object_name
            );
            setProductTypeDetected(res.data.data.predicted_object_name);
            setPredictedLogId(res.data.data.prediction_logs_id);
            setProductTypeList(res.data.data.product_type_list);

            setDeviceColorChr(res.data.data.device_color);
            setDeviceBrandChr(res.data.data.predicted_object_brand);

            setModelNum(res.data.data.predicted_object_model_number);
            setSerialNumber(res.data.data.predicted_object_serial_number);

            setObjectCondition(res.data.data.predicted_object_condition);

            setPredictedObjectDetails(res?.data?.data);

            handleScanSteps(3);
          },
          () => {
            setLoading(false);
          }
        )
      );
    }
  };

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState(localStorage.getItem("emailCompanyInvite") ? localStorage.getItem("emailCompanyInvite") : localStorage.getItem("phoneNumberCompanyInvite") ? localStorage.getItem("phoneNumberCompanyInvite") : "");
  const [codeValue, setCodeValue] = useState(localStorage.getItem("phoneCodeCompanyInvite") ? localStorage.getItem("phoneCodeCompanyInvite") : 1);
  const [isPhone, setIsPhone] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");

  const handleEmailPhone = (e) => {
    // console.log(e.target.value);
    setIsEmailPhoneVal(false);
    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

  };

  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);

  };

  function handleBlur() {
    if (isPhone) {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    } else {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    }
  }

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  const [searchValue, setSearchValue] = useState("")
  const [userId, setUserId] = useState("")
  const [userInvitationId, setUserInvitationId] = useState("")
  const [elements, setElements] = useState([])
  const [isProSelected, setIsProSelected] = useState(false)
  const [createViaRoleLoading, setCreateViaRoleLoading] = useState(false)
  // console.log("userId", userId)

  const getInviteAndRegisteredUserFn = () => {

    if (searchValue.length > 2 || searchValue.length == 0) {
      setElements([])

      const data = new FormData();
      data.append("user_id_ids", localStorage.getItem("user_id"));
      data.append("role_id_int", 1)
      data.append("pagination_flag", 0);
      data.append("page_index", 1);
      data.append("page_size", 10000);
      data.append("sorting_order", "ASC");
      data.append("sorting_column_name", "");
      data.append("search_area", searchValue);

      dispatch(
        getInviteAndRegisteredUsersApi(data, (res) => {

          setElements(res.data.data);

        }, (err) => {

        })
      );
    }
  }

  useEffect(() => {
    if (responseBox && permissionArray.includes("ASSIGN SERVICE REQUEST")) {
      getInviteAndRegisteredUserFn();
    }
  }, [searchValue, responseBox])

  const handleCreateViaRoleFn = () => {
    // console.log(dateTime, unixTimestamp, unixEndTime);

    // const startTimeUnix = convertToUnixTime();
    // const endTimeUnix = calculateEndTime(startTimeUnix);
    if (!userId && !userInvitationId) {
      setIsProSelected(true)
    }

    if (!isPhone) {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    } else {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    }

    if ((userId || userInvitationId) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
      if (isPhone) {
        setCreateViaRoleLoading(true)
        let createTicketData = new FormData();

        createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
        // createTicketData.append("address_id_ids",0)
        //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
        // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
        createTicketData.append(
          "object_name_chr",
          productNameForTicket ? productNameForTicket : productTypeDetected
        );

        createTicketData.append("object_category_chr", objectCategoryName);
        modelNum && createTicketData.append("object_model_number_chr", modelNum);
        serialNumber && createTicketData.append("serial_number_chr", serialNumber);
        description &&
          createTicketData.append("problem_description_chr", description);
        deviceBrandChr &&
          createTicketData.append("device_brand_chr", deviceBrandChr);
        deviceColorChr &&
          createTicketData.append("device_color_chr", deviceColorChr);
        image &&
          createTicketData.append(
            "attachment0",
            image,
            "uploadAttachedImage0.jpeg"
          );
        uploadAttachedImage1 != null &&
          createTicketData.append(
            "attachment1",
            uploadAttachedImage1,
            "uploadAttachedImage1.jpeg"
          );
        uploadAttachedImage2 != null &&
          createTicketData.append(
            "attachment2",
            uploadAttachedImage2,
            "uploadAttachedImage2.jpeg"
          );

        // createTicketData.append("is_scheduling_flag", 1);
        // createTicketData.append("unix_datetime_stamp_start", startTimeUnix);
        // createTicketData.append("unix_datetime_stamp_end", endTimeUnix);

        // createTicketData.append(
        //   "amount_after_discount",
        //   finalAmountAfterPromoCodeApplied
        // );

        verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);

        qrResult && createTicketData.append("qr_info_chr", qrResult);
        objectCondition && createTicketData.append("condition_chr", objectCondition);

        userInvitationId && createTicketData.append("invitation_id_chr", userInvitationId);
        userId && createTicketData.append("assigned_to_chr", userId);
        createTicketData.append("email_chr", '');
        createTicketData.append("phone_code_id_int", parseInt(codeValue) || 1);
        createTicketData.append("phone_number_int", parseInt(emailPhoneValue) || 0);

        dispatch(
          createViaRoleApi(
            createTicketData,
            (res) => {
              // localStorage.setItem("triggerFlag", 1);
              // localStorage.setItem("roomCode", res.data.data.room_id);
              // localStorage.setItem("call_log_id",res.data.data.room_id)
              // navigate("/videoCall")
              // console.log(res)
              setCreateViaRoleLoading(false)
              handleCloseDocScheduleModal();

              handleOpenScheduleSuccess();

              setResponseBox(false);

              localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
              localStorage.setItem("proType", res.data.data.product_type_chr);
              setScheduleLoader(false);

              setResponceMsg(res.data.message);
              setToasterType("success");
              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (err) => {
              // console.log(err)
              setCreateViaRoleLoading(false)
              setScheduleLoader(false);

              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);

            }
          )
        );
      } else {
        setCreateViaRoleLoading(true)
        let createTicketData = new FormData();

        createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
        // createTicketData.append("address_id_ids",0)
        //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
        // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
        createTicketData.append(
          "object_name_chr",
          productNameForTicket ? productNameForTicket : productTypeDetected
        );

        createTicketData.append("object_category_chr", objectCategoryName);
        modelNum && createTicketData.append("object_model_number_chr", modelNum);
        serialNumber && createTicketData.append("serial_number_chr", serialNumber);
        description &&
          createTicketData.append("problem_description_chr", description);
        deviceBrandChr &&
          createTicketData.append("device_brand_chr", deviceBrandChr);
        deviceColorChr &&
          createTicketData.append("device_color_chr", deviceColorChr);
        image &&
          createTicketData.append(
            "attachment0",
            image,
            "uploadAttachedImage0.jpeg"
          );
        uploadAttachedImage1 != null &&
          createTicketData.append(
            "attachment1",
            uploadAttachedImage1,
            "uploadAttachedImage1.jpeg"
          );
        uploadAttachedImage2 != null &&
          createTicketData.append(
            "attachment2",
            uploadAttachedImage2,
            "uploadAttachedImage2.jpeg"
          );

        // createTicketData.append("is_scheduling_flag", 1);
        // createTicketData.append("unix_datetime_stamp_start", startTimeUnix);
        // createTicketData.append("unix_datetime_stamp_end", endTimeUnix);

        // createTicketData.append(
        //   "amount_after_discount",
        //   finalAmountAfterPromoCodeApplied
        // );

        verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);

        qrResult && createTicketData.append("qr_info_chr", qrResult);
        objectCondition && createTicketData.append("condition_chr", objectCondition);

        userInvitationId && createTicketData.append("invitation_id_chr", userInvitationId);
        userId && createTicketData.append("assigned_to_chr", userId);
        createTicketData.append("email_chr", emailPhoneValue);
        // createTicketData.append("phone_code_id_int", parseInt(codeValue) || 1);
        // createTicketData.append("phone_number_int", parseInt(emailPhoneValue) || 0);

        dispatch(
          createViaRoleApi(
            createTicketData,
            (res) => {
              // localStorage.setItem("triggerFlag", 1);
              // localStorage.setItem("roomCode", res.data.data.room_id);
              // localStorage.setItem("call_log_id",res.data.data.room_id)
              // navigate("/videoCall")
              // console.log(res)
              setCreateViaRoleLoading(false)
              handleCloseDocScheduleModal();

              handleOpenScheduleSuccess();

              setResponseBox(false);

              localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
              localStorage.setItem("proType", res.data.data.product_type_chr);
              setScheduleLoader(false);

              setResponceMsg(res.data.message);
              setToasterType("success");
              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (err) => {
              // console.log(err)
              setCreateViaRoleLoading(false)
              setScheduleLoader(false);

              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);

            }
          )
        );
      }
    }
  }

  // Function for the invite pro while creating service
  const [inviteProTrigger, setInviteProTrigger] = useState(false);
  const handleOpenInviteProModal = () => {
    setInviteProTrigger(true);
    handleCloseOnlyResBox();
  }

  const handleCloseInviteProModal = () => {
    setInviteProTrigger(false);
    getInviteAndRegisteredUserFn();
    setResponseBox(true);
  }
  const [showScanInstruction, setShowScanInstruction] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setShowScanInstruction(false);
    }, 6000);
    return () => clearTimeout(id);
  }, []);


  return (
    <>
      <div
        className="row d-flex justify-content-center align-items-center"
        style={{ height: "" }}
      >

        {DIYProjectId && (
          <div className="row mx-0">
            <div className="col-12 px-0 d-flex justify-content-center align-items-center">
              <span className="fs-4 text-center font-w600 text-black">{`Create DIY project service request`}</span>
            </div>
          </div>
        )}

        <div className="row mx-0">
          <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
            {!showScanInstruction &&
              <span className="fs-4 text-center text-black px-2">
                {`Step 1 of 3`}
              </span>
            }

            <span className="fs-4 text-center text-black px-2">
              {showScanInstruction ?
                <>
                  {`It only takes a minute to begin talking with a Pro -`}<strong>{` let's get started!`}</strong>
                </> :
                <>
                  {imgSrc ?
                    <>
                      {`Adjust the photo frame`}
                    </> :
                    <>
                      {`Take a Pic of the item`}
                    </>
                  }
                </>
              }
            </span>
          </div>
        </div>




        <Card className="bg-white" style={{ width: "98%" }}>
          {/* <Card.Header className="d-block">
            <Card.Title style={{ fontWeight: '700' }}>Scan Device </Card.Title>
          </Card.Header> */}
          {!showFeedback && (
            <Card.Body className="card-body-video p-1">




              <div
                className="row d-flex justify-content-center align-items-center position-relative"
                style={{ height: "" }}
              >



                <>
                  {!imgSrc && (
                    <>
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{
                          width: 1280,
                          height: 720,
                          facingMode: "environment",
                          aspectRatio: 16 / 9
                        }}
                        style={{ maxWidth: "800px", maxHeight: '500px' }}
                      />

                      {/* {(showScanInstruction) &&
                        <>
                          <div className="row w-100 position-absolute" style={{ top: '9px' }}>
                            <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                              <div className="" style={{ width: "100%", minWidth: '800px', maxWidth: "800px", height: '500px', maxHeight: '500px' }}>
                                <video
                                  src="/media/videos/createServiceInstruction.mp4"
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                  muted
                                  autoPlay
                                  loop
                                  onClick={() => setShowScanInstruction(false)}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      } */}

                    </>
                  )}
                </>


                {imgSrc && (
                  <div>
                    <ImageCropper imgSrc={imgSrc} canvasRef={canvasRef} setCrop={setCrop} />

                  </div>
                )}
              </div>
            </Card.Body>
          )}
          {showFeedback && !responseBox && !scheduleModalTrigger && !paymentConfirmModal && !ocrModalTrigger && !sourcingInfoModalTrigger && !inviteProTrigger && (
            <div
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100dvw',
                height: '100dvh',
                zIndex: '10',
                background: 'white',
                overflow: 'auto',
                transition: "top 1s ease-in-out"
              }}
            >
              <div
                style={{
                  // height: (prodTypeId === undefined &&
                  //   brandId === undefined) ? 'auto' : "80vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1rem",
                }}>
                {/* --------------------    Box Main  --------------------------------- */}
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <div className="row mx-0">
                    <div className="col-12 px-0 d-flex justify-content-end align-items-center">
                      <span
                        className="cursor-pointer fs-1 text-black text-hovered"
                        onClick={() => { setResponseBox(true) }}
                      >
                        <i className="bi bi-x" ></i>
                      </span>
                    </div>
                  </div>
                  <div className="row mx-0 mb-3">
                    <div className="align-items-center col-12 d-flex justify-content-center px-0 ">
                      <span className="font-w700 fs-4 text-black">{`Define device`}</span>
                    </div>
                  </div>
                  {/* -----------------   Button On top --------------------------- */}
                  {false &&
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}>
                        {isSearch ? (
                          <p className="label_name">{"Searched Result"}</p>
                        ) : catId !== undefined && prodTypeId !== undefined ? (
                          //  && brandId !== undefined
                          <p className="label_name">{""}</p>
                        ) : (
                          <p
                            className="label_name"
                            style={{
                              fontSize: "16px",
                              color: "black",
                              fontWeight: "700",
                            }}>
                            Find a device
                          </p>
                        )}


                        {!isSearch ? (
                          <PrimaryButton
                            buttonName={"Go Back"}
                            onClick={handleBack}
                            style={{ width: '120px' }}
                          />
                        ) : (
                          <PrimaryButton
                            buttonName={"Back"}
                            onClick={() => {
                              setSearchText("");
                              setIsSearch(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  }

                  {/* ------------------   BreadCrumb -------------------------------- */}
                  {/* <div
                style={{
                  width: "100%",
                  height: "30px",
                  background: "lightgray",
                  padding: "4px",
                  borderRadius: "3px",
                }}>
                <span className="breadCrumbText">
                  {breadCatName === undefined ? "" : breadCatName}

                  {breadProductName === undefined ? "" : breadProductName}

                  {breadBrandName === undefined ? "" : breadBrandName}
                </span>
              </div> */}

                  {/* --------------------------   Inner Div  Center -------------------------------------------------- */}
                  <div
                    style={{
                      width: "100%",
                      height:
                        catId !== undefined &&
                          prodTypeId !== undefined &&
                          brandId !== undefined
                          ? "360px"
                          : "auto",
                      // overflow: "auto",
                      marginBottom: "10px",
                      marginTop: "10px",
                      position: "relative",
                    }}>
                    <>
                      {/*  ====================   Categories ======================================================= */}

                      {
                        // prodTypeId === undefined &&
                        // brandId === undefined && 
                        (
                          <div>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                padding: "5px",
                              }}>
                              {catArr.map((ele, ind) => {
                                return (
                                  ele?.category_name_chr !== "Inspection" && (
                                    <div
                                      className="category-indivitual-box"
                                      onClick={() => {
                                        handleSetCatId(ele);
                                        setParticularID(ind);
                                        setIsCustomResMsg(true);
                                      }}>
                                      <Card
                                        className="bg-white h-100"
                                        style={{
                                          marginBottom: "0px",
                                          height: "auto",
                                          borderRadius: "10px",
                                        }}>
                                        <Card.Body>
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                              width: "100%",
                                              height: "80px",
                                            }}>
                                            <img
                                              src={ele?.category_image_url_chr}
                                              style={{
                                                width: "40%",
                                                height: "100%",
                                                objectFit: "contain",
                                              }}
                                              alt={ele?.category_display_name_chr}
                                            />
                                          </div>
                                          <div
                                            className="d-flex align-items-center category-name"
                                            style={{
                                              borderBottom:
                                                particularID == ind &&
                                                "1px solid #ccc",
                                            }}>
                                            <span>{ele.category_display_name_chr}</span>
                                            {particularID == ind ? (
                                              <span
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setParticularID(null);
                                                  setProdTypeArr([]);
                                                }}
                                                style={{ fontSize: "20px" }}>
                                                <i className="bi bi-dash-circle-fill"></i>
                                              </span>
                                            ) : (
                                              <span style={{ fontSize: "20px" }}>
                                                <i className="bi bi-plus-circle-fill"></i>
                                              </span>
                                            )}
                                          </div>

                                          {particularID == ind && (
                                            <>
                                              {productTypeResp ? (
                                                <SkeletonDivElement
                                                  height={"20px"}
                                                  rows={6}
                                                />
                                              ) : (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    padding: "0px 5px",
                                                  }}>
                                                  {prodTypeArr.map((ele, ind) => {
                                                    return (
                                                      <div
                                                        key={ind}
                                                        className="product-type-name"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleSetProductType(
                                                            ele
                                                          );
                                                          setProductTypeDetected(
                                                            ele?.product_type_name_chr
                                                          );
                                                        }}>
                                                        <span>
                                                          {
                                                            ele.product_type_name_chr
                                                          }
                                                        </span>

                                                        <i className="bi bi-chevron-double-right product-type-icon" />
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </div>
                                  )
                                );
                              })}
                            </div>
                            <div className="categories-footer">
                              <p style={{ marginBottom: "0px" }}>
                                We currently only support the device categories
                                listed
                              </p>
                            </div>
                          </div>
                        )
                      }

                      {/* ========================     Products ---------------- */}
                      {false &&
                        catId !== undefined &&
                        prodTypeId === undefined &&
                        brandId === undefined && (
                          <div>
                            {prodTypeArr.map((ele, ind) => (
                              <div
                                style={{
                                  width: "100%",
                                  background: "#fff",
                                  height: "40px",
                                  backgroundColor: "#ffd7c2",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "12px",
                                  justifyContent: "space-between",
                                  marginBottom: "2px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleSetProductType(ele);
                                }}>
                                <p>{ele.product_type_name_chr}</p> {">>"}
                              </div>
                            ))}

                            {addUnknwProdArr.map((ele, ind) =>
                              ele.product_type_id_ids === -1 ? (
                                ""
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    background: "#fff",
                                    height: "40px",
                                    backgroundColor: "#ffd7c2",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "12px",
                                    justifyContent: "space-between",
                                    marginBottom: "2px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    handleSetProductType(ele);
                                  }}>
                                  <p>{ele.product_type_name_chr}</p> {">>"}
                                </div>
                              )
                            )}
                          </div>
                        )}

                      {/* ======================================    Brands ============================================== */}

                      {false &&
                        catId !== undefined &&
                        prodTypeId !== undefined &&
                        brandId === undefined && (
                          <div>
                            {brandArr.map((ele, ind) => (
                              <div
                                style={{
                                  width: "100%",
                                  background: "#fff",
                                  height: "40px",
                                  backgroundColor: "#ffd7c2",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "12px",
                                  justifyContent: "space-between",
                                  marginBottom: "2px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleSetBrandType(ele);
                                }}>
                                <p>{ele.brand_name_chr}</p> {">>"}
                              </div>
                            ))}
                          </div>
                        )}

                      {false &&
                        catId !== undefined &&
                        prodTypeId !== undefined && (
                          // brandId !== undefined &&
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              margin: "40px 1px",
                              width: "100%",
                              color: "black",
                              fontSize: "18px",
                              fontWeight: "600",
                            }}>
                            <span className="problemDescriptiontxt">
                              Describe the{" "}
                              {productNameForTicket
                                ? productNameForTicket
                                : productTypeDetected}{" "}
                              problem and we will connect you to a{" "}
                              {breadCatButtonName
                                ? breadCatButtonName
                                : predictedObjectClassName}{" "}
                              professional to assist you.
                            </span>

                            <div
                              className="problemDescriptionMessageBox"
                              style={{ width: "50%" }}>
                              <TextArea
                                labelName={"Describe Problem"}
                                placeholder={"Enter message here"}
                                value={description}
                                onChange={handleDescription}
                              />
                            </div>
                          </div>
                        )}
                    </>

                    <>
                      {" "}
                      <div>
                        {searchedArr.map((ele, ind) => (
                          <div
                            style={{
                              width: "100%",
                              background: "#fff",
                              height: "40px",
                              backgroundColor: "#ffd7c2",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              padding: "12px",
                              marginBottom: "2px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleSetSearchedArrEle(ele);
                            }}>
                            <p
                              className="searchResP"
                              style={{
                                fontWeight: searchText.match(
                                  ele.category?.category_name_chr
                                )
                                  ? 700
                                  : "",
                              }}>
                              {ele.category?.category_name_chr} {" >> "}{" "}
                            </p>

                            <p
                              className="searchResP"
                              style={{
                                fontWeight: searchText.match(
                                  ele.product_type?.product_type_name_chr
                                )
                                  ? 700
                                  : "",
                              }}>
                              {ele.product_type?.product_type_name_chr}
                              {" >> "}{" "}
                            </p>

                            {
                              <p
                                className="searchResP"
                                style={{
                                  fontWeight: searchText.match(
                                    ele.product_brand?.brand_name_chr
                                  )
                                    ? 700
                                    : "",
                                }}>
                                {ele.product_brand?.brand_name_chr}{" "}
                              </p>
                            }
                          </div>
                        ))}
                      </div>
                    </>

                    {/* --------------------------  Inner Div End -------------------------------------- */}

                    {/* ------------------------  Bottom Buttons ----------------------------------- */}

                    <div
                      style={{
                        width: "100%",
                        height: "40px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        top: "50%",
                      }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          alignItems: "center",
                          flexDirection: "column",
                        }}>
                        {false &&
                          catId !== undefined &&
                          prodTypeId !== undefined ? (
                          // && brandId !== undefined
                          <>
                            <div
                              className="scan-tab-btn-bottom"
                              style={{ width: "37%", marginBottom: "10px" }}>
                              <PrimaryButton
                                buttonName={`Connect me to ${breadCatButtonName
                                  ? breadCatButtonName
                                  : predictedObjectClassName
                                  } professional`}
                                style={{ width: "100%" }}
                                onClick={
                                  // setPaymentModal(true)
                                  submitFeedback
                                }
                              />
                            </div>

                            <div
                              className="scan-tab-btn-bottom"
                              style={{ width: "37%" }}>
                              <PrimaryButton
                                buttonName={`Connect Later`}
                                style={{
                                  width: "100%",
                                  backgroundColor: "black",
                                }}
                                onClick={() => handleOpenScheduleModal()}
                              />
                            </div>
                          </>
                        ) : (
                          // : <CircularProgress color="warning" />
                          <></>
                        )}
                      </div>
                    </div>

                    {/* -------------------------   Bottom Buttons end ------------------------------ */}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!showFeedback && (
            <Card.Footer className="border-top-0">
              <div
                className="scan-tab-bottom-btn-group"
                style={{
                  marginTop: showScanInstruction ? '55px' : '0px'
                }}
              >
                {/* {!loading && !isResValue && (
                <div className="scan-tab-bottom-btn-container">
                  <Button onClick={capture} style={{ width: '100%' }}>{"Scan Device"}</Button>
                </div>
              )} */}


                <div className="scan-tab-bottom-btn-container">
                  {imgSrc ? <>
                    <PrimaryButton
                      onClick={() => { setImgSrc(null) }}
                      buttonName={"RESET"}
                      style={{
                        marginRight: "10px",
                        marginTop: "10px",
                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                        border: '2px solid rgba(255, 154, 32, 1)',
                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        fontWeight: '600',
                      }}
                    />
                    <PrimaryButton
                      onClick={handleContinue}
                      buttonName={"CONTINUE"}
                      style={{
                        marginTop: "10px",
                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                        border: '2px solid rgba(255, 154, 32, 1)',
                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        fontWeight: '600',
                      }}
                    />
                  </> : <>
                    <Button
                      onClick={() => {
                        if (showScanInstruction) {
                          setShowScanInstruction(false)
                        } else {
                          capture()
                        }
                        // handleScanSteps(2);
                      }}
                      className="scan-tab-bottom-btn"
                      style={{
                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                        border: '2px solid rgba(255, 154, 32, 1)',
                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        fontWeight: '600',
                      }}
                    >
                      {"SCAN DEVICE"}
                    </Button></>}
                </div>




                <div className="scan-tab-bottom-btn-container">
                  {!imgSrc &&
                    <Button
                      onClick={
                        (e) => {
                          if (showScanInstruction) {
                            setShowScanInstruction(false)
                          } else {
                            handleClickUploadPicture(e)
                          }
                        }
                      }
                      className="scan-tab-bottom-btn bg-white text-black border-none"
                      style={{ fontWeight: '600' }}
                    >
                      {" "}
                      {"UPLOAD IMAGE"}
                    </Button>}
                  <input
                    ref={uploadPicRef}
                    onChange={(e) => {
                      handleUploadPicture(e);
                    }}
                    on
                    className="form-control"
                    type="file"
                    accept="image/*"
                    hidden
                  />
                </div>

                <div className="scan-tab-bottom-btn-container">
                  {permissionArray.includes("ASSIGN SERVICE REQUEST") && !imgSrc &&
                    <Button
                      onClick={() => { setResponseBox(true) }}
                      className="scan-tab-bottom-btn bg-white text-black border-none"
                      style={{ fontWeight: '600' }}
                    >
                      {"SKIP"}
                    </Button>}
                </div>



              </div>
            </Card.Footer>
          )}
        </Card >
      </div >





      {/* Response modal for the scan result confimation */}
      {responseBox && < Modal className="fade" show={true} style={{}} centered size="lg" >
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <>
                <div>
                  <div className="mx-0 row">
                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                      <span
                        onClick={() => handleCloseOnlyResBox()}
                        className="cursor-pointer">
                        <i className="bi bi-x-lg"></i>
                      </span>
                    </div>
                  </div>

                  <div className="mx-0 row mb-2">
                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                      <span>{"Create service request"}</span>
                    </div>
                  </div>

                  <div className="mx-0 row mb-3">
                    {!permissionArray.includes("ASSIGN SERVICE REQUEST") && <div className="col-12 font-w500 fs-6 px-0 text-black text-center">
                      <span>
                        {scanSteps === 2
                          ? `step ${scanSteps} of 3. Tell us a little about what's happening while we process the image.`
                          : `Step 3 of 3. Set up all the details`}
                      </span>
                    </div>}
                  </div>
                </div>

                <div className="row mx-0">
                  <div className="col-lg-6 pe-md-2 ">

                    <div
                      className="bg-light py-2 border"
                      style={{ height: "100%", position: "relative", minHeight: "250px" }}>
                      {loading ? <BackDropReconnecting show={loading} message={"Analzing Device"} /> : <>
                        <div className="row mx-0 ">
                          <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                            {(image || displayImage) && <img
                              className="border"
                              src={
                                scanImageCheck
                                  ? URL.createObjectURL(image)
                                  : displayImage
                              }
                              alt=""
                              style={{ width: "100px", height: "120px" }}
                            />}
                          </div>
                        </div>

                        <div className="mx-0 my-3 row">
                          <div className="col-12 fs-5 fw-bold px-0 text-black text-center">
                            {(!image || !displayImage) && !resValue &&
                              <span className="px-2">
                                {`Please select the product manually or rescan device`}
                              </span>
                            }
                            <span className="">
                              {!isCustomResMsg
                                ? `${resValue}`
                                : `Is this ${objectCategoryName} device?`}
                            </span>
                          </div>
                        </div>

                        {/* Old products shown */}
                        {productTypeList.length > 0 && (
                          <div className="row mx-0">
                            <div
                              className=" col-12 px-2 d-flex align-items-center overflow-auto pb-2"
                              ref={navbarRef}
                              onMouseDown={onMouseDown}
                              onMouseLeave={onMouseLeave}
                              onMouseUp={onMouseUp}
                              onMouseMove={onMouseMove}
                            >


                              {productTypeList.map((ele, ind) => {
                                return (
                                  <div
                                    key={ind}
                                    className={`border me-2 p-2 d-flex justify-content-around align-items-center flex-column position-relative bg-white cursor-pointer
                                       ${((prodTypeId == ele?.product_type_id_ids) || (productNameForTicket == "" && productTypeDetected == ele?.product_type_name_chr))
                                        ? "border-success border-3"
                                        : ""
                                      }`}
                                    style={{
                                      height: "110px",
                                      minWidth: "92px",
                                      maxWidth: "92px",
                                    }}
                                    onClick={() => {
                                      // onClickReject(ele?.product_type_name_chr)
                                      // setProductType(ele?.product_type_name_chr)
                                      setProductNameForTicket("");
                                      setProdTypeId(ele.product_type_id_ids);
                                      setProductTypeDetected(
                                        ele?.product_type_name_chr
                                      );
                                    }}
                                  >
                                    {((prodTypeId == ele?.product_type_id_ids) || (productNameForTicket == "" && productTypeDetected == ele?.product_type_name_chr)) && (
                                      <i
                                        class="bi bi-x-circle"
                                        onClick={(e) => clearProductType(e)}
                                        style={{
                                          position: "absolute",
                                          right: "3px",
                                          top: "1px",
                                          color: "red",
                                          cursor: "pointer",
                                        }}></i>
                                    )}
                                    <img
                                      src={ele?.product_type_image_url_chr ? ele?.product_type_image_url_chr : unavailbleServiceImg}
                                      style={{ width: "50px", height: "50px" }}
                                      alt={ele?.category_name_chr}
                                    />

                                    <span className="text-center text-black font-w500 fs-6">
                                      {ele?.product_type_name_chr}
                                    </span>
                                  </div>
                                );
                              })}

                            </div>
                          </div>
                        )}



                        {false && <>
                          {productTypeList.length > 0 && (
                            <div className="carousel">
                              <button onClick={prevSlide} className="carousel-button prev">Previous</button>
                              <div className="carousel-content">
                                {productTypeList.map((ele, index) => (
                                  <>
                                    <div
                                      key={index}
                                      className={`border me-2 p-2 d-flex justify-content-around align-items-center flex-column position-relative bg-white cursor-pointer carousel-item 
                                       ${prodTypeId == ele?.product_type_id_ids
                                          ? "border-success border-3"
                                          : ""
                                        }`}
                                      // className={`carousel-item ${index === currentIndex ? 'active' : ''}`}
                                      style={{
                                        height: "110px",
                                        minWidth: "92px",
                                        maxWidth: "92px",
                                      }}
                                      onClick={() => {
                                        // onClickReject(ele?.product_type_name_chr)
                                        // setProductType(ele?.product_type_name_chr)
                                        setProductNameForTicket("");
                                        setProdTypeId(ele.product_type_id_ids);
                                        setProductTypeDetected(
                                          ele?.product_type_name_chr
                                        );
                                      }}>
                                      {prodTypeId == ele?.product_type_id_ids && (
                                        <i
                                          class="bi bi-x-circle"
                                          onClick={(e) => clearProductType(e)}
                                          style={{
                                            position: "absolute",
                                            right: "3px",
                                            top: "1px",
                                            color: "red",
                                            cursor: "pointer",
                                          }}></i>
                                      )}
                                      <img
                                        src={ele?.product_type_image_url_chr ? ele?.product_type_image_url_chr : unavailbleServiceImg}
                                        style={{ width: "50px", height: "50px" }}
                                        alt={ele?.category_name_chr}
                                      />

                                      <span className="text-center text-black font-w500 fs-6">
                                        {ele?.product_type_name_chr}
                                      </span>
                                    </div>



                                    {/* <div
                                    key={index}
                                    className={`carousel-item ${index === currentIndex ? 'active' : ''}`}
                                  >
                                    {item}
                                  </div> */}
                                  </>
                                ))}
                              </div>
                              <button onClick={nextSlide} className="carousel-button next">Next</button>
                            </div>)}
                        </>}

                        <div className="mx-0 my-3 row">
                          <div className="col-12 fs-5 font-w500 px-2  d-flex justify-content-evenly align-items-center">
                            {predictionFlag && (
                              <span className=" text-black">{`If not:`}</span>
                            )}
                            <span
                              onClick={() => {
                                handleCloseResponseBox();
                              }}
                              className=" overlay-action-btn p-1 px-2 cursor-pointer rounded font-w600 border border-light"
                              style={{
                                background: 'rgb(215, 225, 243)',
                                color: 'rgb(89 110 145)',
                              }}
                            >
                              {`Rescan device`}
                            </span>
                            <span
                              onClick={() => {
                                handleResponseAgree();
                              }}
                              className=" overlay-action-btn p-1 px-2 cursor-pointer rounded font-w600 border border-light"
                              style={{
                                background: 'rgb(215, 225, 243)',
                                color: 'rgb(89 110 145)',
                              }}
                            >
                              {`Identify manually`}
                            </span>
                          </div>
                        </div></>}

                    </div>


                  </div>

                  <div className="col-lg-6 ps-md-2 d-flex flex-column justify-content-between">
                    <div className="mx-0 row mt-3">
                      {permissionArray.includes("ASSIGN SERVICE REQUEST") &&
                        <>
                          <div className='row mx-0'>
                            <div className='col-12 px-0 mb-2 d-flex justify-content-end align-items-center'>
                              <span
                                className="px-2 py-1 overlay-action-btn cursor-pointer font-w600"
                                onClick={handleOpenInviteProModal}
                              >
                                {`Invite pro`}
                              </span>
                            </div>
                          </div>

                          <div className='row mx-0'>
                            <div className='col-12 px-0'>
                              <SearchableSelectForInvites
                                userArray={elements}
                                handleChangeSearchValue={(e) => { setSearchValue(e) }}
                                handleChangeCode={(e) => {
                                  setUserId(e?.user_id_ids);
                                  setUserInvitationId(e?.invitation_id_ids);
                                  setIsProSelected(false)
                                }}
                                labelName={"Select pro *"}
                                errorOccured={isProSelected}
                                errorMessage={`Please select a pro`}
                              />
                            </div>
                          </div>

                          <div className='row mx-0 mb-2'>
                            <div className='col-12 px-0'>
                              <EmailPhoneCombine
                                label={`Customer's Email or Phone number`}
                                isEnteringNumber={isPhone}
                                setIsEnteringNumber={setIsPhone}
                                handleInputValue={handleEmailPhone}
                                handleChangeCode={handleDropdownValue}
                                errorOccured={isEmailPhoneVal}
                                inputValue={emailPhoneValue}
                                handleOnBlur={handleBlur}
                                defaultCodeValue={codeValue}
                                errorMessage={
                                  // validEmail_OR_MobileNumberText
                                  loginErrorMsg
                                }
                                isRequired={true}
                              />
                            </div>
                          </div>
                        </>
                      }




                      <div className="col-12 px-0">
                        <TextArea
                          labelName={"Problem description"}
                          value={description}
                          onChange={handleDescription}
                          onBlur={() => { }}
                        />
                      </div>

                      <div className="col-12 px-0">
                        {!loading ? <InputField
                          labelName={"Device brand"}
                          value={deviceBrandChr}
                          onChange={handleDeviceBrandChr}
                          onBlur={() => { }}
                        /> : <SkeletonDivElement height={'40px'} marginBottom={'10px'} borderRadius={'0px'} />}
                      </div>

                      {/* <div className="col-12 px-0 d-flex align-items-center"> */}
                      {
                        !loading ?
                          <>
                            <InputField
                              labelName={"Model number"}
                              value={modelNum}
                              onChange={handleModelNum}
                              onBlur={() => { }}
                            />

                            {/* <div
                                className="align-items-center d-flex fs-3 justify-content-center mb-3 ms-2 rounded-1 overlay-action-btn cursor-pointer"
                                onClick={() => {
                                  handleOpenOcrModal();
                                  startCameraOcr();
                                }}
                                style={{
                                  height: "40px",
                                  width: "50px",
                                  border: "1px solid rgb(179 179 179 / 64%)",
                                }}>
                                <div className="tooltipCustom">
                                  <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content', zIndex: 10 }}>{"Scan model"}</span>
                                  <span>
                                    <i className="bi bi-camera"></i>
                                  </span>
                                </div>
                              </div> */}
                          </>

                          : <SkeletonDivElement height={'40px'} marginBottom={'10px'} borderRadius={'0px'} />}

                      {/* </div> */}

                      {/* <div className="col-12 px-0">
                        {!loading ? <InputField
                          labelName={"Serial number"}
                          value={serialNumber}
                          onChange={handleSerialNumber}
                          onBlur={() => { }}
                        /> : <SkeletonDivElement height={'40px'} marginBottom={'10px'} borderRadius={'0px'} />}
                      </div> */}

                      {/* <div className="col-12 px-0 d-flex align-items-center">
                        <>
                          <TextArea
                            labelName={"Qr info"}
                            value={`${qrResult}`}
                            rows="2"
                            // onChange={()=>{setQrResult(e.target.value)}}
                            onBlur={() => { }}
                          />


                          <div
                            className="align-items-center d-flex fs-3 justify-content-center mb-3 ms-2 rounded-1 overlay-action-btn cursor-pointer"
                            onClick={() => {
                              handleQrModalStatus();
                            }}
                            style={{
                              height: "53px",
                              width: "50px",
                              border: "1px solid rgb(179 179 179 / 64%)",
                            }}>
                            <div className="tooltipCustom">
                              <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content', zIndex: 10 }}>{"QR Scanner"}</span>
                              <span>
                                <i className="bi bi-qr-code-scan"></i>
                              </span>
                            </div>
                          </div>
                        </>
                      </div> */}

                      {/* <div className="col-12 px-0">
                        <TextArea
                          labelName={"Qr Result"}
                          value={qrResult}
                          rows="2"
                          // onChange={()=>{setQrResult(e.target.value)}}
                          onBlur={() => { }}
                        />
                      </div> */}

                    </div>

                    <div>
                      {/*  Schedule call code */}
                      {/* <div className="row mx-0 mb-1">
                        <div className="col-12 px-0">
                          <div className="d-flex"
                            title={`${(!productNameForTicket || !productTypeDetected) && "Please select product type"}`}
                          >
                            <div
                              onClick={() => {
                                handleOpenSourcingInfoModal();
                                handleSourcingInfoFn();
                              }}
                              style={{
                                pointerEvents: productNameForTicket || productTypeDetected ? "auto" : "none",
                                opacity: productNameForTicket || productTypeDetected ? 1 : 0.5,
                              }}
                              className="align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-1 py-2 text-hovered">
                              <i className="bi bi-filetype-pdf pe-2"></i>
                              <span>{"Get sourcing info"} </span>
                              <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                            </div>

                          </div>
                        </div>
                      </div> */}


                      {!permissionArray.includes("ASSIGN SERVICE REQUEST") && <div className="row mx-0 mb-1">
                        <div className="col-12 px-0">
                          <div className="d-flex">
                            <div
                              onClick={() => {
                                // handleOpenScheduleModal()
                                handleOpenScheduleModal();
                              }}
                              style={{
                                pointerEvents: objectCategoryName
                                  ? "auto"
                                  : "none",
                                opacity: objectCategoryName ? 1 : 0.5,
                              }}
                              className="align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-1 py-2 text-hovered">
                              <i className="bi bi-calendar4-week pe-2"></i>
                              <span>{"Schedule for Future day and time"} </span>
                              <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                            </div>

                          </div>
                        </div>
                      </div>}
                      {/* <div className="row mx-0 mb-1">
                        <div className="col-12 px-0">
                          <div className="d-flex">
                            <div

                              onClick={handleQrModalStatus}
                              style={{
                                pointerEvents: objectCategoryName
                                  ? "auto"
                                  : "none",
                                opacity: objectCategoryName ? 1 : 0.5,
                              }}
                              className="align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-1 py-2 text-hovered">
                              <i className="bi bi-calendar4-week pe-2"></i>

                              <span>{"Scan Qr/Bar code"} </span>
                              <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                            </div>

                          </div>
                        </div>
                      </div> */}


                    </div>
                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PrimaryButton
                          buttonName={`SUBMIT`}
                          isLoading={createViaRoleLoading}
                          loadingMessage={"SUBMITTING..."}
                          onClick={() => {
                            if (permissionArray.includes("ASSIGN SERVICE REQUEST")) {
                              handleCreateViaRoleFn();
                            } else {
                              // Removed the payment flow for new service
                              if (paymentGatewayFlag && false) {
                                // setPaymentModal(true)
                                handleOpenPaymentModalTrigger();
                              } else {
                                submitFeedback();
                              }
                            }
                          }}
                          style={{
                            width: "100%",
                            pointerEvents: objectCategoryName
                              ? "auto"
                              : "none",
                            opacity: objectCategoryName ? 1 : 0.5,
                            background:
                              "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                            border: "2px solid rgba(255, 154, 32, 1)",
                            boxShadow:
                              "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="row mx-0 mt-3">
                    <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column text-black ">
                      <div className="text-center">
                        <span>{`By pressing the "Submit" button, you agree to Chilll`}</span>
                      </div>
                      <div className="text-center">
                        <a
                          className="terms-condition-link"
                          href="https://chilll.com/chilll-terms-conditions/"
                          target="_blank"
                          rel="noreferrer">
                          <span className="font-w600 cursor-pointer">{`Terms of Service`}</span>
                        </a>
                        <span>{` and `}</span>
                        <a
                          className="terms-condition-link"
                          href="https://chilll.com/privacy-policy/"
                          target="_blank"
                          rel="noreferrer">
                          <span className="font-w600 cursor-pointer">{`Privacy Policy`}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>
          </div>

          {/* --------------------- */}
          {/* <div
          className="d-flex align-items-center justify-content-center"
          style={{ padding: "30px", flexDirection: "column" }}>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "600",
              textAlign: "center",
              padding: "20px",
            }}>
            {text}
          </div>

          <img src={displayImage} alt="" style={{ width: "100px", height: "100px" }} />

          <div
            className="fs-6"
            style={{
              fontWeight: "600",
              textAlign: "center",

            }}>
            {predictedObjectClassName}
          </div>

          {productTypeList.length > 0 &&
            <div className="detected-product-main-container">
              <p style={{ color: 'black' }}>{`Examples of ${predictedObjectClassName} devices`}</p>
              <div className="detected-product-sub-container" >
                {
                  productTypeList.map((ele, ind) => {
                    return (
                      <div className="detected-product-individual" style={{ border: (productType == ele?.product_type_name_chr) ? '3px solid #07a107' : '' }}
                        onClick={() => {
                          // onClickReject(ele?.product_type_name_chr)
                          setProductType(ele?.product_type_name_chr)
                        }
                        } key={ind} >
                        {productType == ele?.product_type_name_chr && <i class="bi bi-x-circle" onClick={(e) => clearProductType(e)} style={{ position: 'absolute', right: '3px', top: '1px', color: 'red', cursor: 'pointer' }}></i>}
                        <img src={ele?.product_type_image_url_chr} style={{ width: "70%" }} alt={ele?.category_name_chr} />
                        <span style={{ textAlign: 'center', color: 'black', fontWeight: '500', fontSize: '11px' }}>{ele?.product_type_name_chr}</span>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          }

          {predictionFlag &&
            <div className="d-flex align-items-center" style={{ justifyContent: 'space-between', width: '80%', marginTop: '9px' }}>

              <PrimaryButton
                style={{ backgroundColor: 'black', width: '49%' }}
                onClick={onClickAccept}
                buttonName={"No"}
              />

              <PrimaryButton
                style={{ width: '49%' }}
                onClick={() => onClickReject(productType)}
                buttonName={"Yes"}
              />




            </div>
          }

          {!predictionFlag &&
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                pointerEvents: loading ? 'none' : 'auto',
                opacity: loading ? 0.5 : 1
              }}>

              <WhiteGreenButton
                onClick={onClickReject}
                buttonName={buttonNameA}
                className={'white-background-btn'}
                variant={'primary'}
              />

              <WhiteGreenButton
                onClick={onClickAccept}
                buttonName={buttonNameB}
                className={'green-background-btn'}
                variant={'primary'}
              />

              <PrimaryButton
                style={{ width: '33%', margin: '0px 5px' }}
                buttonName={"Upload Picture"}
                onClick={handleClickUploadPicture}
              />
              <input ref={uploadPicRef} onChange={(e) => { handleUploadPicture(e) }} on className="form-control" type="file" accept="image/*" hidden />


            </div>
          }
        </div> */}
        </Modal.Body>
      </Modal >}

      {/* OCR modal */}
      < Modal
        className="fade"
        show={ocrModalTrigger}
        style={{}}
        centered
        size="" >
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <>
                <div className="mx-0 row">
                  <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                    <span
                      onClick={() => handleCloseOcrModal()}
                      className="cursor-pointer">
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="mx-0 row mb-2">
                  <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                    <span>{"Scan model number"}</span>
                  </div>
                </div>

                <div
                  className="mx-0 row  mb-3 "
                  style={{ height: "400px", width: "100%" }}>
                  <div className="col-12 font-w600 fs-3 px-0 text-center text-black position-relative">
                    {ocrLoading && <ResponceForAPI show={ocrLoading} />}
                    <span
                      className="position-absolute fs-7"
                      style={{
                        top: "10px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: "1",
                      }}>
                      {"Focus your camera on model number"}
                    </span>
                    <video
                      ref={videoRefOcr}
                      autoPlay
                      playsInline
                      width="100%"
                      height="400px"
                      style={{
                        objectFit: "cover",
                        border: "2px solid #ff7a35",
                      }}
                      muted={true}></video>
                    <canvas
                      ref={canvasRefOcr}
                      // width="640"
                      // height="400"
                      style={{ display: "none" }}></canvas>
                  </div>
                </div>

                <div className="mx-0 row mb-2">
                  <div className="col-12 font-w600 px-0 text-center text-black ">
                    <PrimaryButton
                      buttonName={"SCAN"}
                      onClick={captureImageOcr}
                      style={{
                        width: "100%",
                        background: "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                        border: "2px solid rgba(255, 154, 32, 1)",
                        boxShadow: "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                      }}
                      loadingMessage={"SCANING"}
                      isLoading={ocrLoading}
                    />
                  </div>
                </div>

                {/* <div className='mx-0 row mb-2'>
                  <div className='col-12 font-w600 px-0 text-center text-black '>
                    {capturedImage && <img src={capturedImage} alt="Captured" style={{ width: '100%' }} />}
                  </div>
                </div> */}
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal >

      {/* <ScanResultModal
        text={resValue}
        modalStatus={responseBox}
        onClickReject={handleCloseResponseBox}
        onClickAccept={() => {
          handleResponseAgree();
        }}
        buttonNameA={predictionFlag === false ? `${btnReScan.charAt(0)}${btnReScan.slice(1).toLowerCase()}` : "Yes"}
        buttonNameB={predictionFlag === false ? `${btnIdentifyManually.charAt(0)}${btnIdentifyManually.slice(1).toLowerCase()}` : "No"}
        predictedObjectClassName={predictedObjectClassName}
        productTypeList={productTypeList}
        predictionFlag={predictionFlag}
        handleClickUploadPicture={handleClickUploadPicture}
        uploadPicRef={uploadPicRef}
        handleUploadPicture={handleUploadPicture}
        loading={loading}
        displayImage={scanImageCheck ? URL.createObjectURL(image) : displayImage}
        handleCloseOnlyResBox={handleCloseOnlyResBox}
      /> */}

      {backDropLoaderResp && <DummyBackdropLoader />}
      {
        backDropLoaderRejectedCase && (
          <BackDropLoaderRejectedCase
            openLoader={backDropLoaderRejectedCase}
            descriptionVal={description}
            modelNumVal={modelNum}
            timeSlotArr={timeSlotArr}
            communicationModeArr={comminicationModeArr}
          />
        )
      }
      {
        backDropLoaderStatus && (
          <BackDrop
            showUpdate={true}
            openLoader={backDropLoaderStatus}
            descriptionVal={description}
            modelNumVal={modelNum}
            timeSlotArr={timeSlotArr}
            communicationModeArr={comminicationModeArr}
          />
        )
      }
      {errBackDropLoaderResp && <ErrorBackdropLoader resMessage={responceMsg} />}
      {
        updateServiceRequestStatus && (
          <UpdateServiceRequest
            objectCategoryName={objectCategoryName}
            descriptionVal={description}
            modelNumVal={modelNum}
            timeSlotArr={timeSlotArr}
            communicationModeArr={comminicationModeArr}
            attachedImg={image}
          />
        )
      }

      {/* <FcmTokenVerify
        FcmModalTrigger={FcmModalTrigger}
        handleCloseFCM={handleCloseFCM}
        titleTXT={'Failed to set searching pro protocol'}
        bodyTXT={'You might not able to connect with Pro. Please allow your notification for this site or turn off incognitive mode and then refresh'}
      /> */}

      {/* New modal for payment confirmation */}
      <Modal
        className="fade"
        show={paymentConfirmModal}
        style={{}}
        centered
        size="lg">
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <>
                <div>
                  <div className="mx-0 row">
                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                      <span
                        onClick={() => handleClosePaymentModalTrigger()}
                        className="cursor-pointer">
                        <i className="bi bi-x-lg"></i>
                      </span>
                    </div>
                  </div>

                  <div className="mx-0 row mb-4">
                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                      <span>{`Confirm payment`}</span>
                    </div>
                  </div>
                </div>

                <div className="row mx-0">
                  <div className="col-lg-6 pe-lg-2 ">
                    <div className=" p-4 border">
                      <div className="border-bottom mx-0 pb-3 row">
                        <div className="col-12 px-0 d-flex align-items-center">
                          <div className="  h-100" style={{ width: "80px" }}>
                            <img
                              className="border"
                              src={
                                scanImageCheck
                                  ? URL.createObjectURL(image)
                                  : displayImage
                              }
                              alt=""
                              style={{ width: "80px", height: "100px" }}
                            />
                          </div>
                          <div className="d-flex flex-column h-100 ps-3 w-100">
                            <div className="row mx-0">
                              <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                <div className="fs-7">
                                  <span className="text-black font-w500">{`Created: `}</span>
                                  <span className="font-w600">
                                    {formatUnixTimestamp(
                                      Math.floor(new Date().getTime() / 1000)
                                    )}
                                  </span>
                                </div>

                                <div>
                                  <i
                                    className="bi bi-pencil-fill ps-2 fs-6 text-black cursor-pointer text-hovered"
                                    onClick={() => {
                                      setResponseBox(true);
                                      setPaymentConfirmModal(false);
                                    }}></i>
                                </div>
                              </div>
                            </div>
                            <div className="row mt-1">
                              <div className="col-12 px-0">
                                <span className="fs-5 fw-bold text-black">{`${description
                                  ? description
                                  : `Problem description not specified`
                                  }`}</span>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0">
                                <span className="fs-7">{`${objectCategoryName} Pro from Chilll network`}</span>
                              </div>
                            </div>

                            <div className="row mt-1">
                              <div className="col-12 px-0 d-flex align-items-center justify-content-end">
                                <div
                                  className=" px-3 py-1 rounded-pill fs-7 text-white font-w600"
                                  style={{
                                    zIndex: 1,
                                    background: "rgba(79, 93, 116, 1)",
                                  }}>
                                  <span>{` ${objectCategoryName} ${(productNameForTicket ||
                                    productTypeDetected) &&
                                    `/ ${productNameForTicket
                                      ? productNameForTicket
                                      : productTypeDetected
                                    }`
                                    }`}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0 py-2">
                        <div className="col-12 px-0 d-flex align-items-center">
                          <span className="fs-5 font-w600 text-black">{`Price details`}</span>
                        </div>
                      </div>

                      <div className="row mx-0 pb-2 ">
                        <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                          <div>
                            <span className=" text-black">{`${callDurationTimeLimit} minutes with a Pro`}</span>
                            <i className="bi bi-info-circle  ps-2"></i>
                          </div>
                          <span className=" font-w600 text-black">{`${USDollar.format(
                            parseFloat(callChargeAmount?.toFixed(2))
                          )}`}</span>
                        </div>
                      </div>

                      {verifiedPromoCode && (
                        <div className="row mx-0 pb-2 ">
                          <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                            <div>
                              <span className=" text-black">
                                {"Promo code discount"}
                              </span>
                            </div>
                            <span className=" font-w600 text-success">{`-${USDollar.format(
                              parseFloat(callChargeAmount?.toFixed(2)) -
                              parseFloat(
                                finalAmountAfterPromoCodeApplied?.toFixed(2)
                              )
                            )}`}</span>
                          </div>
                        </div>
                      )}

                      <div className="row mx-0 border-bottom"></div>

                      <div
                        style={{
                          pointerEvents: (parseFloat(totalCreditsInCents?.toFixed(2) / 100) >= parseFloat(callChargeAmount?.toFixed(2))) ? 'auto' : 'none',
                          opacity: (parseFloat(totalCreditsInCents?.toFixed(2) / 100) >= parseFloat(callChargeAmount?.toFixed(2))) ? 1 : 0.5,
                        }}
                      >
                        <div className="row mx-0 py-2">
                          <div className="col-12 px-0 d-flex align-items-center">
                            <span className="fs-5 font-w600 text-black">{`Chilll credit balance`}</span>
                          </div>
                        </div>

                        <div className="row mx-0 pb-2 ">
                          <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                            <div className="d-flex">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="refund"
                                name="refund"
                                onChange={(e) => { setIsCreditsUsed(!isCreditsUsed) }}
                                value={isCreditsUsed}
                                checked={isCreditsUsed}
                              />
                              <span
                                className='ps-3 pt-1 text-black cursor-pointer'
                                onClick={() => { setIsCreditsUsed(!isCreditsUsed) }}
                              >
                                {`Available balance`}
                              </span>
                            </div>
                            {!isCreditsUsed ?
                              <span className=" font-w600 text-black">{`${USDollar.format(
                                parseFloat(totalCreditsInCents?.toFixed(2) / 100)
                              )}`}</span> :
                              <span className=" font-w600 text-black">{`
                              (${USDollar.format(parseFloat(totalCreditsInCents?.toFixed(2) / 100))} - ${USDollar.format(parseFloat(callChargeAmount?.toFixed(2)))}) = 
                              ${USDollar.format(
                                (parseFloat(totalCreditsInCents?.toFixed(2) / 100) - parseFloat(callChargeAmount?.toFixed(2)))
                              )}`}</span>
                            }
                          </div>
                        </div>

                        {(parseFloat(totalCreditsInCents?.toFixed(2) / 100) < parseFloat(callChargeAmount?.toFixed(2))) && <div className="row mx-0 pb-2 ">
                          <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                            <div className="d-flex">
                              <span
                                className='text-black'
                              >
                                {`(Your credit balance is insufficient to use)`}
                              </span>
                            </div>
                          </div>
                        </div>}

                      </div>

                      <div className="row mx-0 border-bottom"></div>

                      <div className="row mx-0 py-2 ">
                        <div className="col-12 px-0 d-flex justify-content-between align-items-center fs-4">
                          <span className="  font-w600  text-black">
                            {"Total"}
                          </span>
                          {isCreditsUsed ?
                            <>
                              <span className=" font-w600 text-black">
                                {`${USDollar.format(
                                  parseFloat(
                                    finalAmountAfterPromoCodeApplied?.toFixed(2)
                                  )
                                )}`}
                              </span>
                            </> :
                            <>
                              {!verifiedPromoCode && (
                                <span className=" font-w600 text-black">
                                  {`${USDollar.format(
                                    parseFloat(callChargeAmount?.toFixed(2))
                                  )}`}
                                </span>
                              )}

                              {verifiedPromoCode && (
                                <span className=" font-w600 text-black">
                                  {`${USDollar.format(
                                    parseFloat(
                                      finalAmountAfterPromoCodeApplied?.toFixed(2)
                                    )
                                  )}`}
                                </span>
                              )}
                            </>
                          }

                        </div>
                      </div>

                      {!isCreditsUsed &&
                        <>
                          <div className="row mx-0 py-2 ">
                            <div className="col-sm-7 pe-sm-1 d-flex  align-items-center">
                              <div className="w-100">
                                <InputField
                                  labelName={"Promo code"}
                                  placeholderName={"Enter promo code"}
                                  onChange={handlePromoCode}
                                  onBlur={handlePromoCodeBlurCheck}
                                  errorOccured={isPromoCodeErr}
                                  errorMeesage={"enter valid promo code"}
                                  value={`${promoCode}`}
                                />
                              </div>
                            </div>

                            <div className="col-sm-5 ps-sm-1 pb-3">
                              <PrimaryButton
                                buttonName={"Apply"}
                                onClick={handleCheckPromoCodeFn}
                                loadingMessage={"Checking..."}
                                isLoading={promoCodeLoading}
                                style={{
                                  width: "100%",
                                  background:
                                    promoCodeLoading || promoCode === ""
                                      ? "lightgray"
                                      : "",
                                  color:
                                    promoCodeLoading || promoCode === ""
                                      ? "grey"
                                      : "",
                                  pointerEvents:
                                    promoCodeLoading || promoCode === ""
                                      ? "none"
                                      : "auto",
                                  border: "none",
                                }}
                              />
                            </div>
                          </div>

                          {Object.keys(promoCodeRes)?.length > 0 && (
                            <>
                              {Object.keys(promoCodeRes?.created_for_data)?.length > 0 &&
                                <div className="row mx-0 p-3 bg-light mb-2">
                                  <div className="col-12 px-0 d-flex align-items-center">
                                    <span className="fs-6  text-black">
                                      {`You will be connected to the`} <span className='fw-bold'>{`${promoCodeRes?.created_for_data?.first_name_chr} (Pro)`}</span> {`from Chilll network.`}
                                    </span>
                                  </div>
                                </div>
                              }
                            </>
                          )}
                        </>
                      }

                      {
                        // verifiedPromoCode && finalAmountAfterPromoCodeApplied == 0 ?
                        //   <></> :
                        <div className="row mx-0 p-3 bg-light">
                          <div className="col-12 px-0 d-flex align-items-center">
                            <span className="fs-6  text-black">
                              {`${callChargeDescription}`}
                            </span>
                          </div>
                        </div>
                      }
                    </div>
                  </div>

                  <div className="col-lg-6 ps-lg-2 d-flex flex-column justify-content-between">
                    <div className="mt-2 mb-4">
                      {(verifiedPromoCode || isCreditsUsed) &&
                        finalAmountAfterPromoCodeApplied == 0 ? (
                        <div className="row mx-0">
                          <div className="col-12 px-0 text-center">
                            <span className="fs-4 fw-bold text-success">
                              {`${isCreditsUsed ? "Chilll credits" : "Promo code"} applied successfully`}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="row mx-0">
                          <div className="col-12 px-0">
                            <label className="mb-1">
                              <strong>
                                {"Select your preferred payment method"}
                              </strong>
                            </label>

                            <div className="position-relative">
                              <div
                                className={`${isPaymentMethodErr && "border-danger"
                                  } w-100 border rounded d-flex justify-content-between align-items-center cursor-pointer`}
                                style={{
                                  height: "35px",
                                }}
                                onClick={() => {
                                  setToggleCardsMenu(!toggleCardsMenu);
                                  setIsPaymentMethodErr(false);
                                }}>
                                <div className="ps-3 ">
                                  {cardArr?.length > 0 ? (
                                    <>
                                      {cardArr?.map((element, index) => {
                                        return (
                                          <>
                                            {element.is_default_card && (
                                              <>
                                                <span className="font-w600 text-black">
                                                  {`${element?.card?.brand?.toUpperCase()} `}
                                                </span>
                                                <span className="text-black">
                                                  {`*${element?.card?.last4}`}
                                                </span>
                                              </>
                                            )}
                                          </>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <span className="ps-2">
                                      {`Add new payment method`}
                                    </span>
                                  )}
                                </div>

                                <div
                                  className="fs-4 font-w600 d-flex justify-content-center align-items-center border-start"
                                  style={{ height: "25px", width: "35px" }}>
                                  <i class="bi bi-chevron-down"></i>
                                </div>
                              </div>

                              {isPaymentMethodErr && (
                                <small className="text-danger">{`please select payment method`}</small>
                              )}

                              {toggleCardsMenu && (
                                <div
                                  className="mt-1 w-100 border rounded d-flex flex-column align-items-center shadow"
                                  style={{
                                    pointerEvents: primaryCardLoading ? "none" : "auto",
                                    opacity: primaryCardLoading ? "0.5" : "1",
                                  }}
                                >
                                  {cardArr?.map((element, index) => {
                                    return (
                                      <>
                                        <div
                                          key={index}
                                          className="border-bottom p-2 text-black w-100 overlay-action-btn d-flex align-items-center cursor-pointer"
                                          onClick={(e) =>
                                            selectPrimaryCardFn(e, element)
                                          }
                                          style={{
                                            pointerEvents: element?.is_default_card ? "none" : "auto",
                                            opacity: element?.is_default_card ? "0.7" : "1",
                                          }}
                                        >
                                          <div className="mx-2">
                                            <input
                                              className="form-check-input"
                                              style={{
                                                display: "inline-block",
                                              }}
                                              name="selectCard"
                                              type="radio"
                                              value={`${element?.id}`}
                                              onChange={(e) => {
                                                selectPrimaryCardFn(e, element);
                                              }}
                                              checked={element?.is_default_card}
                                            />
                                          </div>

                                          <div className="mt-1">
                                            <span className="font-w600">
                                              {`${element?.card?.brand?.toUpperCase()} `}
                                            </span>
                                            <span className="">
                                              {`*${element?.card?.last4}`}
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    );
                                  })}

                                  <>
                                    <div
                                      className="align-items-center d-flex overlay-action-btn p-2 text-black w-100 cursor-pointer"
                                      onClick={() => {
                                        handleOpenAddNewPaymentMethod();
                                        setIsPaymentMethodErr(false);
                                      }}>
                                      <span className="fs-4 mx-2">
                                        <i className="bi bi-plus-circle-fill"></i>
                                      </span>
                                      <span className="font-w600">
                                        {`Add new payment method`}
                                      </span>
                                    </div>
                                  </>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div>
                      <div>
                        <div className="row mx-0">
                          <div className="col-12 px-0">
                            <PrimaryButton
                              buttonName={`CONFIRM PAYMENT`}
                              onClick={() => {
                                // handleConfirmPay();
                                handlePaymentConfirmation();
                              }}
                              style={{
                                width: "100%",
                                background:
                                  "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                border: "2px solid rgba(255, 154, 32, 1)",
                                boxShadow:
                                  "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="row mx-0 mt-3">
                    <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column text-black ">
                      <div className="text-center">
                        <span>{`By pressing the "CONFIRM PAYMENT" button, you agree to Chilll`}</span>
                      </div>
                      <div className="text-center">
                        <a
                          className="terms-condition-link"
                          href="https://chilll.com/chilll-terms-conditions/"
                          target="_blank"
                          rel="noreferrer">
                          <span className="font-w600 cursor-pointer">{`Terms of Service`}</span>
                        </a>
                        <span>{` and `}</span>
                        <a
                          className="terms-condition-link"
                          href="https://chilll.com/privacy-policy/"
                          target="_blank"
                          rel="noreferrer">
                          <span className="font-w600 cursor-pointer">{`Privacy Policy`}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal to add new payment methods */}
      <Modal className="fade" show={addNewPaymentMethodTrigger} centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <>
                <div className="mx-0 row">
                  <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                    <span
                      onClick={() => {
                        handleCloseAddNewPaymentMethod();
                        setPaymentConfirmModal(true);
                      }}
                      className="cursor-pointer">
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="mx-0 row mb-4">
                  <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                    <span>{"Payment methods"}</span>
                  </div>
                </div>

                <div className="row mx-0 mb-2">
                  <div className={`col-12 px-0 text-center`}>
                    <span className="font-w600 fs-5">
                      {supportedPaymentMethodsArr.length > 0
                        ? "You can add a new payment method"
                        : "No payment method available"}
                    </span>
                  </div>
                </div>

                {customLoadingForSupportedMethods ? (
                  <>
                    <SkeletonDivElement
                      height={"80px"}
                      marginBottom={"10px"}
                      borderRadius={"0px"}
                    />
                    <SkeletonDivElement
                      height={"80px"}
                      marginBottom={"10px"}
                      borderRadius={"0px"}
                    />
                    <SkeletonDivElement
                      height={"80px"}
                      marginBottom={"10px"}
                      borderRadius={"0px"}
                    />
                  </>
                ) : (
                  <>
                    {supportedPaymentMethodsArr?.length > 0 && (
                      <div>
                        {supportedPaymentMethodsArr?.map((element, index) => {
                          return (
                            <>
                              <div
                                key={index}
                                className="row mx-0 border shadow-sm p-3 mb-2 overlay-action-btn cursor-pointer"
                                style={{
                                  pointerEvents: element?.is_active_ysn
                                    ? "auto"
                                    : "none",
                                  opacity: element?.is_active_ysn ? 1 : 0.5,
                                }}
                                onClick={() => {
                                  handleCloseAddNewPaymentMethod();
                                  !customerID
                                    ? handleOpenAddCardFirstTime()
                                    : handleOpenAddNewCard();
                                }}>
                                <div
                                  className={`col-12 d-flex align-items-center`}>
                                  <div
                                    className="align-items-cente bg-light border d-flex fs-3 justify-content-center rounded-circle text-black"
                                    style={{ height: "35px", width: "35px" }}>
                                    <i class="align-self-center bi bi-gear-wide-connected"></i>
                                  </div>

                                  <div className="fs-4 font-w600 ps-3 text-black">
                                    <span>{element?.name_chr}</span>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    )}
                  </>
                )}
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal to add new credit card first time */}
      <Modal className="fade" show={addCardFirstTimeTrigger} centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <>
                <div className="mx-0 row">
                  <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                    <span
                      onClick={() => handleCloseAddCardFirstTime()}
                      className="cursor-pointer">
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="mx-0 row mb-4">
                  <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                    <span>{"Add new card"}</span>
                  </div>
                </div>

                <>
                  <form onSubmit={handleSubmitStripe}>


                    <div>
                      {/* <CardInput /> */}

                      <div className='row mx-0'>
                        <div className='col-12 px-0'>
                          <label className={`font-w600 mb-1 ${cardNumberError ? 'text-red' : ''}`}>Card Number *</label>
                          <div
                            style={{
                              padding: '10px',
                              border: cardNumberError ? '1px solid red' : '1px solid #DBDBDB',
                              borderRadius: '6px'
                            }}
                          >
                            <CardNumberInput onChange={handleCardNumberChangeStripe} autocomplete="off" />
                          </div>
                          {cardNumberError && <div className="text-red fs-12">{cardNumberError}</div>}
                        </div>
                      </div>

                      <div className='row mx-0 mt-2'>
                        <div className='col-6 pe-2'>
                          <label className={`font-w600 mb-1 ${cardExpiryError ? 'text-red' : ''}`}>Expiry Date *</label>
                          <div
                            style={{
                              padding: '10px',
                              border: cardExpiryError ? '1px solid red' : '1px solid #DBDBDB',
                              borderRadius: '6px'
                            }}
                          >
                            <CardExpiryInput onChange={handleCardExpiryChangeStripe} />
                          </div>
                          {cardExpiryError && <div className="text-red fs-12">{cardExpiryError}</div>}
                        </div>

                        <div className='col-6 ps-2'>
                          <label className={`font-w600 mb-1 ${cardCvcError ? 'text-red' : ''}`}>CVC *</label>
                          <div
                            style={{
                              padding: '10px',
                              border: cardCvcError ? '1px solid red' : '1px solid #DBDBDB',
                              borderRadius: '6px'
                            }}
                          >
                            <CardCvcInput onChange={handleCardCvcChangeStripe} />
                          </div>
                          {cardCvcError && <div className="text-red fs-12">{cardCvcError}</div>}
                        </div>
                      </div>

                      <div className='row mx-0 mt-3'>
                        <div className='col-12 px-0'>
                          <StandardInputField
                            labelName="Name on card"
                            placeholderName={'Name on card'}
                            type={'text'}
                            name={'cardHolder'}
                            value={cardInfo.cardHolder}
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                            onBlur={handleCardHolderNameBlurCheck}
                            errorOccured={isCardHolderNameErr}
                            errorMeesage={'Enter valid cardholder name'}
                            isRequired={true}
                          />
                        </div>
                      </div>

                      <div className='row mx-0'>
                        <div className='col-12 px-0'>
                          <StandardInputField
                            labelName={"Zip code"}
                            placeholderName={'Zip code'}
                            value={zipCode}
                            onChange={(e) => { handleZipCode(e) }}
                            onBlur={() => { handleZipCodeBlurCheck() }}
                            errorOccured={isZipCodeErr}
                            errorMeesage={`Enter valid zip code`}
                            isRequired={true}
                          />
                        </div>
                      </div>

                      <div className='col-12 px-0  mt-2'>
                        <PrimaryButton
                          onClick={(e) => handleSubmitStripe(e)}
                          buttonName={"ADD NEW CARD"}
                          type={"submit"}
                          loadingMessage={"LOADING..."}
                          isLoading={apiResponce}
                          style={{
                            width: '100%',
                            background: 'linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)',
                            border: 'none',
                            boxShadow: 'rgba(45, 204, 99, 0.24) 0px 6px 12px 0px',
                          }}
                          disabled={!stripe}
                        />
                      </div>

                    </div>

                  </form>
                </>

                {/* <>
                  <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
                    <div className="row mx-0">
                      <div className={`col-12 px-0 `}>
                        <InputField
                          labelName="Card number"
                          placeholderName={"1234 1234 1234 1234"}
                          type={"text"}
                          name={"cardNumber"}
                          value={formatedNumber}
                          onChange={handleCardNumberChange}
                          onFocus={handleInputFocus}
                          maxLength={19}
                          onBlur={handleCardNumberBlurCheck}
                          errorOccured={isCardNumberErr}
                          errorMeesage={"Enter valid card number"}
                        />
                      </div>
                    </div>

                    <div className="row mx-0 justify-content-between">
                      <div className="col-6 px-0 pe-2">
                        <InputField
                          labelName="MM/YY"
                          placeholderName={"MM/YY"}
                          type={"text"}
                          name={"expiryDate"}
                          value={cardInfo.expiryDate}
                          onChange={handleExpiryDateChange}
                          onFocus={handleInputFocus}
                          onBlur={handleCardExpBlurCheck}
                          errorOccured={isCardExpErr}
                          errorMeesage={"Enter valid exp. date"}
                        />
                      </div>

                      <div className="col-6 px-0  ps-2">
                        <InputField
                          labelName="CVV"
                          placeholderName={"CVV"}
                          type={"text"}
                          name={"cvc"}
                          value={cardInfo.cvc}
                          onChange={handleCVCChange}
                          onFocus={handleInputFocus}
                          onBlur={handleCardCVCBlurCheck}
                          errorOccured={isCardCVCErr}
                          errorMeesage={"Enter valid cvc"}
                          maxLength={4}
                        />
                      </div>
                    </div>

                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <InputField
                          labelName="Name on card"
                          placeholderName={"Cardholder Name"}
                          type={"text"}
                          name={"cardHolder"}
                          value={cardInfo.cardHolder}
                          onChange={handleInputChange}
                          onFocus={handleInputFocus}
                          onBlur={handleCardHolderNameBlurCheck}
                          errorOccured={isCardHolderNameErr}
                          errorMeesage={"Enter valid cardholder name"}
                        />
                      </div>
                    </div>

                    <div className="row mx-0 justify-content-between mt-2">
                      <div className="col-12 px-0 mb-2">
                        <PrimaryButton
                          onClick={(e) => handleSubmit(e)}
                          buttonName={"Add new card"}
                          type={"submit"}
                          loadingMessage={"Loading..."}
                          isLoading={apiResponce}
                          style={{
                            width: "100%",
                            background: "green",
                            border: "none",
                          }}
                        />
                      </div>
                    </div>
                  </form>
                </> */}
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Old payment confirmation modal */}
      <Modal className="fade" show={paymentModal}>
        <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>
            {!customerID ? "Please save card details" : "Payment confirmation"}
          </Modal.Title>
          {/* <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => handleClose()}
          >

          </Button> */}
        </Modal.Header>
        <Modal.Body>
          {!customerID ? (
            <>
              <div>
                <Cards
                  number={cardInfo.cardNumber}
                  name={cardInfo.cardHolder}
                  expiry={cardInfo.expiryDate}
                  cvc={cardInfo.cvc}
                  focused={cardInfo.focus}
                />
              </div>

              {/* <form  style={{ marginTop: '20px' }}> */}
              <div style={{ marginTop: "20px" }}>
                <InputField
                  labelName="Cardholder Name"
                  placeholderName={"Cardholder Name"}
                  type={"text"}
                  name={"cardHolder"}
                  value={cardInfo.cardHolder}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  onBlur={handleCardHolderNameBlurCheck}
                  errorOccured={isCardHolderNameErr}
                  errorMeesage={"Enter valid cardholder name"}
                />

                <InputField
                  labelName="Card Number"
                  placeholderName={"1234 1234 1234 1234"}
                  type={"text"}
                  name={"cardNumber"}
                  // value={cardInfo.cardHolder}
                  onChange={handleCardNumberChange}
                  onFocus={handleInputFocus}
                  maxLength={19}
                  onBlur={handleCardNumberBlurCheck}
                  errorOccured={isCardNumberErr}
                  errorMeesage={"Enter valid card number"}
                />

                <div className="combine-input-fileds">
                  <div className="comapany-address" style={{ width: "49%" }}>
                    <InputField
                      labelName="Expiry Date"
                      placeholderName={"MM/YY"}
                      type={"text"}
                      name={"expiryDate"}
                      value={cardInfo.expiryDate}
                      onChange={handleExpiryDateChange}
                      onFocus={handleInputFocus}
                      onBlur={handleCardExpBlurCheck}
                      errorOccured={isCardExpErr}
                      errorMeesage={"Enter valid exp. date"}
                    />
                  </div>

                  <div className="comapany-address" style={{ width: "49%" }}>
                    <InputField
                      labelName="CVC"
                      placeholderName={"CVC"}
                      type={"text"}
                      name={"cvc"}
                      value={cardInfo.cvc}
                      onChange={handleCVCChange}
                      onFocus={handleInputFocus}
                      onBlur={handleCardCVCBlurCheck}
                      errorOccured={isCardCVCErr}
                      errorMeesage={"Enter valid cvc"}
                      maxLength={3}
                    />
                  </div>
                </div>

                <div style={{ marginTop: "20px", color: "red" }}>
                  <span>
                    <strong>Note:</strong> By clicking on below save button, on
                    successful video call with professional you agree to pay{" "}
                    <strong>${"20.00"}</strong>
                  </span>
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{ marginTop: "10px", justifyContent: "flex-end" }}>
                  <div>
                    <PrimaryButton
                      buttonName={"Save card"}
                      onClick={(e) => {
                        handleSubmitPay(e);
                      }}
                    />
                  </div>

                  <div style={{ marginLeft: "5px" }}>
                    <PrimaryButton
                      buttonName={"Cancel"}
                      onClick={() => setPaymentModal(false)}
                    />
                  </div>
                </div>
              </div>
              {/* </form> */}
            </>
          ) : (
            <>
              <div
                className="d-flex align-items-center"
                style={{ justifyContent: "flex-end" }}>
                <span>
                  <i
                    className="bi bi-info-circle-fill"
                    style={{ color: "red", fontSize: "15px" }}></i>{" "}
                  <strong
                    onClick={() => handleOpenAddNewCard()}
                    className="update-card-text">
                    Add new card
                  </strong>
                </span>
              </div>
              <div className="saved-card-container-modal">
                {/* <Cards
                  number={lastFourDigitCard}
                  name={initialNameOnCard}
                  expiry={`${initialMonthExpCard}${initialYearExpCard}`}
                /> */}
                {cardArr?.map((element, index) => {
                  return (
                    <>
                      <div
                        className="saved-card-individual-box-modal"
                        key={index}>
                        <div className="saved-card-individual-actions-modal">
                          <div className="saved-card-individual-name-modal">
                            <i className="bi bi-credit-card-2-back card-icon-modal"></i>
                            <span className="saved-card-individual-type-modal">
                              {(element?.card?.brand).toUpperCase()}
                            </span>
                          </div>

                          <span></span>
                        </div>

                        <div
                          className="saved-card-details-modal"
                          style={{ margin: "5px" }}>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "600",
                            }}>{`XXXX XXXX XXXX ${element?.card?.last4}`}</span>

                          <div
                            className="d-flex align-items-center"
                            style={{ justifyContent: "space-between" }}>
                            <span>{element?.billing_details?.name}</span>
                            <span>{`${element?.card?.exp_month}/${element?.card?.exp_year}`}</span>
                          </div>
                        </div>

                        <div className="saved-card-update-modal">
                          <span
                            onClick={() =>
                              handleOpenUpdateCard(element, false)
                            }>
                            <i
                              className="bi bi-info-circle-fill"
                              style={{
                                color: "red",
                                fontSize: "12px",
                              }}></i>{" "}
                            <strong className="update-card-text">
                              Update card
                            </strong>
                          </span>
                        </div>

                        <div className="saved-card-primary-check-modal">
                          {!element.is_default_card && (
                            <div className="saved-card-primary-box">
                              <div
                                onClick={(e) =>
                                  selectPrimaryCardFn(e, element)
                                }>
                                <input
                                  type="radio"
                                  id={element?.id}
                                  value={element?.id}
                                  name="selectPrimaryCard"
                                  style={{
                                    display: "inline-block",
                                    padding: "10px",
                                  }}
                                />
                                <span
                                  style={{
                                    marginLeft: "8px",
                                    marginTop: "5px",
                                  }}>
                                  <label
                                    for={element?.id}
                                    style={{ cursor: "pointer" }}>
                                    Set as primary card
                                  </label>
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                        {element.is_default_card && (
                          <div className="save-card-default-text-modal">
                            Primary card
                          </div>
                        )}
                      </div>
                    </>
                  );
                })}
              </div>

              <div style={{ margin: "15px 0px", fontSize: "18px" }}>
                <span>
                  By clicking on below confirm button, on successful video call
                  with professional you agree to pay <strong>${"20.00"}</strong>
                </span>
              </div>

              <div
                className="d-flex align-items-center"
                style={{ marginTop: "10px", justifyContent: "flex-end" }}>
                <div>
                  <PrimaryButton
                    buttonName={"Yes, I confirm"}
                    onClick={handleConfirmPay}
                  />
                </div>

                <div style={{ marginLeft: "5px" }}>
                  <PrimaryButton
                    buttonName={"Cancel"}
                    onClick={() => setPaymentModal(false)}
                  />
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal for schedule call for later */}
      <>
        <Modal
          className="fade"
          show={scheduleModalTrigger}
          // onHide={handleClose}
          centered
          size="">
          {/* <Modal.Header style={{ borderBottom: 'none' }}>
            <Modal.Title style={{ display: 'flex', }}>

              {toggleForSchedule === 1 ? "Do you want to connect now or schedule for later?" :
                toggleForSchedule === 2 ? "Select date and time to schedule call for later" : ""}

            </Modal.Title>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleCloseDocScheduleModal()}
            >

            </Button>
          </Modal.Header> */}
          <Modal.Body style={{ padding: "5px" }}>
            <div className="row mx-0">
              <div className="col-12 px-0 position-relative">
                <div
                  className="mx-0 row  schedule-modal-close-btn position-absolute text-hovered "
                  style={{
                    top: "5px",
                    right: "10px",
                  }}>
                  <div className="col-12 d-flex fs-4 justify-content-end px-0">
                    <span
                      onClick={() => handleCloseDocScheduleModal()}
                      className="cursor-pointer">
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="row mx-0 ">
                  <div
                    className="col-sm-6 px-2 rounded-1"
                    style={{
                      background: "rgba(79, 93, 116, 1)",
                    }}>
                    <div className="mx-0 row m-2">
                      <div className="col-12  px-0 text-center text-white fs-7 fw-light my-3 px-2">
                        <span>{`Please note that the standard call duration is ${callDurationTimeLimit} minutes`}</span>
                      </div>
                    </div>

                    <div className="mx-0 row">
                      <div className="col-12  px-0 text-center">
                        <InputField
                          type="time"
                          labelName={"Time"}
                          placeholder={"Date and time"}
                          value={currentTime}
                          // onChange={(e) => setCurrentTime(e.target.value)}
                          onChange={handleTimeChange}
                          errorOccured={isDateTimeErr}
                          errorMeesage={"Please enter date and time"}
                        />
                      </div>
                    </div>

                    <div className="row mx-0">
                      <div className="col-12 px-0 d-flex justify-content-center">
                        <DatePicker
                          selected={selectedDate}
                          onChange={handleDateChange}
                          // dateFormat="MMMM d, yyyy" // Format of the date displayed
                          // isClearable={true} // Shows a clear button to clear the selection
                          // showYearDropdown
                          scrollableMonthYearDropdown
                          inline // This prop makes the calendar always visible
                          style={{}}
                          minDate={today} // Disables all past dates before today
                          formatWeekDay={(nameOfDay) =>
                            nameOfDay.substring(0, 3)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6" style={{}}>
                    <div className="row h-100 w-100">
                      <div className="col-12 p-3 d-flex flex-column justify-content-between">
                        <div>
                          <div className="mx-0 row text-black my-2">
                            <div className="col-12 px-0 text-center d-flex align-items-cente justify-content-center">
                              <img
                                src={calendarImg}
                                alt="Calendar"
                                style={{ height: "70px", width: "70px" }}
                              />
                            </div>
                          </div>

                          <div className="mx-0 row text-black mb-3">
                            <div className="col-12 font-w600 fs-3 px-0 text-center">
                              <span>{"Schedule a call"}</span>
                            </div>
                          </div>

                          <div className="mx-0 row mb-3">
                            <div className="col-12  px-0 text-center">
                              <span>
                                {
                                  "Set the desired date and time for your video call or set it to go live right now"
                                }
                              </span>
                            </div>
                          </div>

                          <div className="mx-0 row">
                            <div
                              className="col-12  px-0 text-center rounded p-2 d-flex align-items-center justify-content-center flex-column"
                              style={{
                                background: "rgba(244, 248, 255, 1)",
                                border: "1px solid rgba(199, 212, 234, 1)",
                              }}>
                              <span>{`Scheduled date & time`}</span>
                              <span className="fs-5 text-black font-w600">{`${formatUnixTimestamp(
                                convertToUnixTime()
                              )}`}</span>
                            </div>
                          </div>
                        </div>

                        <div>
                          <div className="mx-0 row mt-3">
                            <div className="col-12  px-0 text-center">
                              <PrimaryButton
                                buttonName={"SAVE CHANGES"}
                                onClick={() => {
                                  if (paymentGatewayFlag) {
                                    // setPaymentModal(true)
                                    handleOpenPaymentModalTrigger();
                                    setIsScheduledCall(true);
                                  } else {
                                    // submitFeedback();
                                    handleSubmitSchedule()
                                  }
                                }}
                                isLoading={scheduleLoader}
                                loadingMessage={"Saving..."}
                                style={{
                                  width: "100%",
                                  background:
                                    "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                  border: "2px solid rgba(255, 154, 32, 1)",
                                  boxShadow:
                                    "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

              <div style={{ width: '100%', marginBottom: '5px', textAlign: 'center' }}>
                <p style={{ fontSize: '14px', fontWeight: '600', color: 'black' }}>{"Select date and time to schedule call for later"}</p>
              </div>


              <div style={{ width: '70%', marginBottom: '15px' }}>
                <InputField
                  type="datetime-local"
                  labelName={"Date and time"}
                  placeholder={"Date and time"}
                  value={dateTime}
                  onChange={handleDateTime}
                  errorOccured={isDateTimeErr}
                  errorMeesage={"Please enter date and time"}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <PrimaryButton
                  buttonName={"Submit"}
                  onClick={() => handleSubmitSchedule()}
                  isLoading={scheduleLoader}
                  loadingMessage={"Submiting..."}
                />
              </div>
            </div> */}
          </Modal.Body>
        </Modal>
      </>

      {/* Modal for Sourcing Info*/}
      <>
        <Modal
          className="fade"
          show={sourcingInfoModalTrigger}
          // onHide={handleClose}
          centered
          size="">
          {/* <Modal.Header style={{ borderBottom: 'none' }}>
            <Modal.Title style={{ display: 'flex', }}>

              {toggleForSchedule === 1 ? "Do you want to connect now or schedule for later?" :
                toggleForSchedule === 2 ? "Select date and time to schedule call for later" : ""}

            </Modal.Title>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleCloseDocScheduleModal()}
            >

            </Button>
          </Modal.Header> */}
          <Modal.Body style={{ padding: "5px" }}>
            <div className="row mx-0">
              <div className="col-12 px-0 position-relative">
                <div
                  className="mx-0 row  schedule-modal-close-btn position-absolute text-hovered "
                  style={{
                    top: "5px",
                    right: "10px",
                  }}>
                  <div className="col-12 d-flex fs-4 justify-content-end px-0">
                    <span
                      onClick={() => handleCloseSourcingInfoModal()}
                      className="cursor-pointer">
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="row mx-0 ">

                  <div className="col-12" style={{}}>
                    <div className="row h-100 w-100">
                      <div className="col-12 p-3 d-flex flex-column justify-content-between">
                        <div>


                          <div className="mx-0 row text-black mb-3">
                            <div className="col-12 font-w600 fs-3 px-0 text-center">
                              <span>{"Sourcing Info"}</span>
                            </div>
                          </div>

                          {sourcingInfoLoading ? <div>
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                          </div> :
                            <>
                              {sourcingInfoArr.length > 0 ?
                                <>
                                  {sourcingInfoArr.map((item, index) => {
                                    return (
                                      <>
                                        <a target="_blank" href={item} rel="noreferrer">
                                          <div className="mx-0 row mb-2">
                                            <div
                                              className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                              style={{
                                                background: "rgba(244, 248, 255, 1)",
                                                border: "1px solid rgba(199, 212, 234, 1)",
                                              }}
                                            >
                                              <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                <div>
                                                  <i className="bi bi-filetype-pdf pe-2"></i>
                                                  <span>
                                                    {`Link ${index + 1}`}
                                                  </span>
                                                </div>

                                                <div>
                                                  <i className="bi bi-chevron-right" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </a>
                                      </>
                                    )
                                  })}
                                </> :
                                <>
                                  <div>
                                    <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                      <div className="mb-2">
                                        <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                      </div>
                                      <span>
                                        {`No record found`}
                                      </span>
                                    </div>
                                  </div>
                                </>

                              }
                            </>}


                        </div>

                        <div>
                          <div className="mx-0 row mt-3">
                            <div className="col-12  px-0 text-center">
                              <PrimaryButton
                                buttonName={"CLOSE"}
                                onClick={() => {
                                  handleCloseSourcingInfoModal();
                                }}
                                style={{
                                  width: "100%",
                                  background:
                                    "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                  border: "2px solid rgba(255, 154, 32, 1)",
                                  boxShadow:
                                    "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

              <div style={{ width: '100%', marginBottom: '5px', textAlign: 'center' }}>
                <p style={{ fontSize: '14px', fontWeight: '600', color: 'black' }}>{"Select date and time to schedule call for later"}</p>
              </div>


              <div style={{ width: '70%', marginBottom: '15px' }}>
                <InputField
                  type="datetime-local"
                  labelName={"Date and time"}
                  placeholder={"Date and time"}
                  value={dateTime}
                  onChange={handleDateTime}
                  errorOccured={isDateTimeErr}
                  errorMeesage={"Please enter date and time"}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <PrimaryButton
                  buttonName={"Submit"}
                  onClick={() => handleSubmitSchedule()}
                  isLoading={scheduleLoader}
                  loadingMessage={"Submiting..."}
                />
              </div>
            </div> */}
          </Modal.Body>
        </Modal>
      </>

      {/* QR Modal Status  */}

      <>
        <Modal
          className="fade"
          show={qrModalStatus}
          // onHide={handleClose}
          centered
        >
          {/* <Modal.Header style={{ borderBottom: "none" }}>
            <Modal.Title>Please show the Qr/Bar code</Modal.Title>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleQrModalStatus()}></Button>
          </Modal.Header> */}
          <Modal.Body>
            <div className="mx-0 row">
              <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                <span
                  onClick={() => handleQrModalStatus()}
                  className="cursor-pointer">
                  <i className="bi bi-x-lg"></i>
                </span>
              </div>
            </div>

            <div className="mx-0 row mb-2">
              <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                <span>{"Please show the Qr/Bar code"}</span>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                alignItems: "center",
                textAlign: "center",
              }}>
              <BarQrScanner onUpdateFn={(value) => { if (value) setQrResult(value) }} />
            </div>

            <div className="mx-0 row mb-2">
              <div className="col-12 font-w600 px-0 text-center text-black ">
                <PrimaryButton
                  buttonName={"SAVE"}
                  onClick={handleQrModalStatus}
                  style={{
                    width: "100%",
                    background: "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                    border: "2px solid rgba(255, 154, 32, 1)",
                    boxShadow: "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                  }}
                />
              </div>
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
            <PrimaryButton buttonName={"Save"} onClick={handleQrModalStatus} />
          </Modal.Footer> */}
        </Modal>
      </>

      {/* Modal for Schedule call success response */}
      <>
        <Modal
          className="fade"
          show={responseScheduleSuccess}
          // onHide={handleClose}
          centered
        >
          {/* <Modal.Header style={{ borderBottom: "none" }}>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleCloseScheduleSuccess()}></Button>
          </Modal.Header> */}
          <Modal.Body>

            <div className="mx-0 row">
              <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                <span
                  onClick={() => handleCloseScheduleSuccess()}
                  className="cursor-pointer">
                  <i className="bi bi-x-lg"></i>
                </span>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <img src={serviceImg} alt="" style={{ maxWidth: "150px" }} />

              {permissionArray.includes("ASSIGN SERVICE REQUEST") ?
                <>
                  <span
                    style={{
                      margin: "3px 20px",
                      fontSize: "16px",
                      fontWeight: 700,
                      color: "black",
                    }}
                  >
                    {`${responceMsg ? responceMsg : "Service request has been created."} `}
                  </span>
                </> :
                <>
                  <span
                    style={{
                      margin: "3px 20px",
                      fontSize: "16px",
                      color: "black",
                    }}>
                    Your service request has been successfully scheduled for : <strong>{`${formatUnixTimestamp(
                      convertToUnixTime()
                    )}`}</strong>
                  </span>

                  <div className="row mx-0 mt-3 w-100">
                    <div className="col-12">
                      <PrimaryButton
                        buttonName={"OK"}
                        onClick={() => handleCloseScheduleSuccess()}
                        style={{
                          width: "100%",
                          background: "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                          border: "2px solid rgba(255, 154, 32, 1)",
                          boxShadow: "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                        }}
                      />
                    </div>
                  </div>
                </>
              }
            </div>
          </Modal.Body>
        </Modal>
      </>


      {
        handleToaster && (
          <ResponceToaster toasterType={toasterType} message={responceMsg} />
        )
      }
      {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}

      {
        updateCardTrigger && (
          <UpdateCardDetails
            updateCardTrigger={updateCardTrigger}
            handleCloseUpdateCard={handleCloseUpdateCard}
            particularCard={particularCard}
          />
        )
      }

      {
        addNewCardTrigger && (
          <AddNewCard
            addNewCardTrigger={addNewCardTrigger}
            handleCloseAddNewCard={handleCloseAddNewCard}
          />
        )
      }

      {inviteProTrigger && <InviteProModal
        inviteProTrigger={inviteProTrigger}
        handleCloseInviteProModal={handleCloseInviteProModal}
      />}
    </>
  );
};

export default Scan;
